"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRANSLATIONS = exports.CURRENT_LANG = exports.T = void 0;
exports.Translate = Translate;
const core_shared_1 = require("@ikegps/core-shared");
var T;
(function (T) {
    T["EMPTY"] = "EMPTY";
    T["IKE_OFFICE"] = "IKE_OFFICE";
    T["IKE_OFFICE_PRO"] = "IKE_OFFICE_PRO";
    T["ACCOUNT_LOCKED"] = "ACCOUNT_LOCKED";
    T["ACCOUNTS_TITLE"] = "ACCOUNTS_TITLE";
    T["ACCOUNTS_NAME"] = "ACCOUNTS_NAME";
    T["ACCOUNTS_ROLE"] = "ACCOUNTS_ROLE";
    T["ACCOUNTS_INVITE"] = "ACCOUNTS_INVITE";
    T["ACCOUNTS_INVITE_TITLE"] = "ACCOUNTS_INVITE_TITLE";
    T["ACCOUNTS_INVITE_CONFIRM"] = "ACCOUNTS_INVITE_CONFIRM";
    T["ACCOUNTS_INVITE_SUCCESS"] = "ACCOUNTS_INVITE_SUCCESS";
    T["ACCOUNTS_INVITE_EXISTING_USER"] = "ACCOUNTS_INVITE_EXISTING_USER";
    T["ACCOUNTS_INVITE_INVALID_USER"] = "ACCOUNTS_INVITE_INVALID_USER";
    T["ACCOUNTS_INVITE_MAX"] = "ACCOUNTS_INVITE_MAX";
    T["ACCOUNTS_INVITE_CHOOSE_USER_ROLE"] = "ACCOUNTS_INVITE_CHOOSE_USER_ROLE";
    T["ACCOUNTS_REMOVE"] = "ACCOUNTS_REMOVE";
    T["ACCOUNTS_REMOVE_TITLE"] = "ACCOUNTS_REMOVE_TITLE";
    T["ACCOUNTS_REMOVE_CONFIRM"] = "ACCOUNTS_REMOVE_CONFIRM";
    T["ACCOUNTS_REMOVE_SUCCESS"] = "ACCOUNTS_REMOVE_SUCCESS";
    T["ACCOUNTS_SET_ROLE"] = "ACCOUNTS_SET_ROLE";
    T["ACCOUNTS_SET_ROLE_TITLE"] = "ACCOUNTS_SET_ROLE_TITLE";
    T["ACCOUNTS_SET_ROLE_CONFIRM"] = "ACCOUNTS_SET_ROLE_CONFIRM";
    T["ACCOUNTS_SET_ROLE_SUCCESS"] = "ACCOUNTS_SET_ROLE_SUCCESS";
    T["BANNER_MESSAGE_PT1"] = "BANNER_MESSAGE_PT1";
    T["BANNER_MESSAGE_PT2"] = "BANNER_MESSAGE_PT2";
    T["OK"] = "OK";
    T["CANCEL"] = "CANCEL";
    T["NEXT"] = "NEXT";
    T["CLOSE"] = "CLOSE";
    T["CONTINUE"] = "CONTINUE";
    T["HERE"] = "HERE";
    T["SEND"] = "SEND";
    T["TRY_AGAIN"] = "TRY_AGAIN";
    T["ACCEPT"] = "ACCEPT";
    T["COLOR"] = "COLOR";
    T["ALTITUDE_MISSING"] = "ALTITUDE_MISSING";
    T["LATITUDE_MISSING"] = "LATITUDE_MISSING";
    T["LONGITUDE_MISSING"] = "LONGITUDE_MISSING";
    T["LOCATION_FIELD_OUT_OF_RANGE"] = "LOCATION_FIELD_OUT_OF_RANGE";
    T["BEARING_INVALID"] = "BEARING_INVALID";
    T["BEARING_MISSING"] = "BEARING_MISSING";
    T["PLACEMENT_MISSING"] = "PLACEMENT_MISSING";
    T["ACCURATE_ANCHOR_RELATED_SPAN_NO_VALUE"] = "ACCURATE_ANCHOR_RELATED_SPAN_NO_VALUE";
    T["ACCURATE_ANCHOR_RELATED_SPAN_NO_SELECTION_BISECT"] = "ACCURATE_ANCHOR_RELATED_SPAN_NO_SELECTION_BISECT";
    T["ACCURATE_ANCHOR_RELATED_SPAN_NO_SELECTION_INLINE"] = "ACCURATE_ANCHOR_RELATED_SPAN_NO_SELECTION_INLINE";
    T["ACCURATE_ANCHOR_RELATED_SPAN_TITLE"] = "ACCURATE_ANCHOR_RELATED_SPAN_TITLE";
    T["DATE_INVALID"] = "DATE_INVALID";
    T["DEPARTMENT"] = "DEPARTMENT";
    T["DRAWABLE_BASE_OFFSET"] = "DRAWABLE_BASE_OFFSET";
    T["DRAWABLE_TITLE"] = "DRAWABLE_TITLE";
    T["STATUS"] = "STATUS";
    T["NONE"] = "NONE";
    T["TYPE"] = "TYPE";
    T["DASHBOARD_POLE_STATUS"] = "DASHBOARD_POLE_STATUS";
    T["DASHBOARD_POLE_LOADING"] = "DASHBOARD_POLE_LOADING";
    T["DASHBOARD"] = "DASHBOARD";
    T["EMAIL_INVALID"] = "EMAIL_INVALID";
    T["EMAIL_EXISTS_IN_DEPARTMENT"] = "EMAIL_EXISTS_IN_DEPARTMENT";
    T["ENTER_VALID_EMAIL"] = "ENTER_VALID_EMAIL";
    T["USER_ALREADY_EXISTS_DESCRIPTION"] = "USER_ALREADY_EXISTS_DESCRIPTION";
    T["ERROR_GENERAL"] = "ERROR_GENERAL";
    T["ERROR_DOWNLOAD_FAIL"] = "ERROR_DOWNLOAD_FAIL";
    T["ERROR_EXPORT"] = "ERROR_EXPORT";
    T["LOADING"] = "LOADING";
    T["LOAD_MORE"] = "LOAD_MORE";
    T["SEARCH"] = "SEARCH";
    T["SEARCH_RES"] = "SEARCH_RES";
    T["CLEAR_SEARCH"] = "CLEAR_SEARCH";
    T["SEARCH_ERROR"] = "SEARCH_ERROR";
    T["LAST_UPDATED_AT"] = "LAST_UPDATED_AT";
    T["TAG_TITLE"] = "TAG_TITLE";
    T["TAG_NAME"] = "TAG_NAME";
    T["TAG_TITLE_SELECTION"] = "TAG_TITLE_SELECTION";
    T["TAG_FILTER"] = "TAG_FILTER";
    T["TAG_FILTER__SEARCH_EMPTY"] = "TAG_FILTER__SEARCH_EMPTY";
    T["TAG_ZOOM"] = "TAG_ZOOM";
    T["TAG_EXISTS"] = "TAG_EXISTS";
    T["TAG_MERGE_TITLE"] = "TAG_MERGE_TITLE";
    T["TAG_MERGE_CONFIRM"] = "TAG_MERGE_CONFIRM";
    T["TAG_PHOTO"] = "TAG_PHOTO";
    T["CLOSE_WINDOW"] = "CLOSE_WINDOW";
    T["COLLECTION_TITLE"] = "COLLECTION_TITLE";
    T["COLLECTION_MISSING"] = "COLLECTION_MISSING";
    T["COLLECTION_MISSING_TITLE"] = "COLLECTION_MISSING_TITLE";
    T["COLLECTION_COLLECTED_AT"] = "COLLECTION_COLLECTED_AT";
    T["COLLECTION_COLLECTED_BY"] = "COLLECTION_COLLECTED_BY";
    T["COLLECTION_UPDATED_AT"] = "COLLECTION_UPDATED_AT";
    T["COLLECTION_UPDATED_BY"] = "COLLECTION_UPDATED_BY";
    T["COLLECTION_ASSIGNED_TO"] = "COLLECTION_ASSIGNED_TO";
    T["COLLECTION_FORM_NAME"] = "COLLECTION_FORM_NAME";
    T["COLLECTION_FORM_VERSION"] = "COLLECTION_FORM_VERSION";
    T["COLLECTION_SHOW_META"] = "COLLECTION_SHOW_META";
    T["COLLECTION_SHOW_ZOOM"] = "COLLECTION_SHOW_ZOOM";
    T["COLLECTION_EXPAND_ALL"] = "COLLECTION_EXPAND_ALL";
    T["COLLECTION_COLLAPSE_ALL"] = "COLLECTION_COLLAPSE_ALL";
    T["COLLECTION_ASSIGN"] = "COLLECTION_ASSIGN";
    T["COLLECTION_UNASSIGNED"] = "COLLECTION_UNASSIGNED";
    T["COLLECTION_ASSIGN_TITLE"] = "COLLECTION_ASSIGN_TITLE";
    T["COLLECTION_ASSIGN_CONFIRM"] = "COLLECTION_ASSIGN_CONFIRM";
    T["COLLECTION_ASSIGN_SUCCESS"] = "COLLECTION_ASSIGN_SUCCESS";
    T["COLLECTION_MOVE"] = "COLLECTION_MOVE";
    T["COLLECTION_MOVE_TITLE"] = "COLLECTION_MOVE_TITLE";
    T["COLLECTION_MOVE_CONFIRM"] = "COLLECTION_MOVE_CONFIRM";
    T["COLLECTION_MOVE_SUCCESS"] = "COLLECTION_MOVE_SUCCESS";
    T["COLLECTION_MOVE_JOB"] = "COLLECTION_MOVE_JOB";
    T["COLLECTION_MOVE_JOB_TITLE"] = "COLLECTION_MOVE_JOB_TITLE";
    T["COLLECTION_MOVE_JOB_INPUT_ERROR"] = "COLLECTION_MOVE_JOB_INPUT_ERROR";
    T["COLLECTION_MOVE_DEPARTMENT"] = "COLLECTION_MOVE_DEPARTMENT";
    T["COLLECTION_STATUS"] = "COLLECTION_STATUS";
    T["CLEAR_COLLECTION_STATUS"] = "CLEAR_COLLECTION_STATUS";
    T["COLLECTION_STATUS_TITLE"] = "COLLECTION_STATUS_TITLE";
    T["COLLECTION_STATUS_CONFIRM"] = "COLLECTION_STATUS_CONFIRM";
    T["COLLECTION_STATUS_SUCCESS"] = "COLLECTION_STATUS_SUCCESS";
    T["COLLECTION_STATUS_CANNOT_CHANGE"] = "COLLECTION_STATUS_CANNOT_CHANGE";
    T["COLLECTION_MIGRATE_FORM"] = "COLLECTION_MIGRATE_FORM";
    T["COLLECTION_MIGRATE_FORM_TITLE"] = "COLLECTION_MIGRATE_FORM_TITLE";
    T["COLLECTION_MIGRATE_FORM_SUCCESS"] = "COLLECTION_MIGRATE_FORM_SUCCESS";
    T["COLLECTION_MIGRATE_FORM_FAIL"] = "COLLECTION_MIGRATE_FORM_FAIL";
    T["COLLECTION_MIGRATE_FORM_BODY_WARNING_TITLE"] = "COLLECTION_MIGRATE_FORM_BODY_WARNING_TITLE";
    T["COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT1"] = "COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT1";
    T["COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT2"] = "COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT2";
    T["COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT3"] = "COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT3";
    T["COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT4"] = "COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT4";
    T["COLLECTION_MIGRATE_FORM_BODY"] = "COLLECTION_MIGRATE_FORM_BODY";
    T["COLLECTION_MIGRATE_FORM_BODY_NO_FORMS"] = "COLLECTION_MIGRATE_FORM_BODY_NO_FORMS";
    T["COLLECTION_UPDATE_FORM"] = "COLLECTION_UPDATE_FORM";
    T["COLLECTION_UPDATE_FORM_TITLE"] = "COLLECTION_UPDATE_FORM_TITLE";
    T["COLLECTION_UPDATE_FORM_CONFIRM"] = "COLLECTION_UPDATE_FORM_CONFIRM";
    T["COLLECTION_UPDATE_FORM_SUCCESS"] = "COLLECTION_UPDATE_FORM_SUCCESS";
    T["COLLECTION_UPDATE_FORM_CURRENT_REVISION"] = "COLLECTION_UPDATE_FORM_CURRENT_REVISION";
    T["COLLECTION_UPDATE_FORM_LATEST_REVISION"] = "COLLECTION_UPDATE_FORM_LATEST_REVISION";
    T["COLLECTION_UPDATE_FORM_ERROR"] = "COLLECTION_UPDATE_FORM_ERROR";
    T["COLLECTION_UPDATE_HAS_LATEST_FORM"] = "COLLECTION_UPDATE_HAS_LATEST_FORM";
    T["COLLECTION_UPDATE_FORM_ERROR_TITLE"] = "COLLECTION_UPDATE_FORM_ERROR_TITLE";
    T["COLLECTION_UPDATE_FORM_FIELD_MISSING"] = "COLLECTION_UPDATE_FORM_FIELD_MISSING";
    T["COLLECTION_UPDATE_FORM_FIELD_VALUE_MISSING"] = "COLLECTION_UPDATE_FORM_FIELD_VALUE_MISSING";
    T["COLLECTION_UPDATE_FORM_REASON"] = "COLLECTION_UPDATE_FORM_REASON";
    T["COLLECTION_UPDATE_FORM_FIELD_NAME"] = "COLLECTION_UPDATE_FORM_FIELD_NAME";
    T["COLLECTION_UPDATE_FORM_VALUE"] = "COLLECTION_UPDATE_FORM_VALUE";
    T["COLLECTION_UPDATE_FORM_WARNING_TITLE"] = "COLLECTION_UPDATE_FORM_WARNING_TITLE";
    T["COLLECTION_UPDATE_FORM_WARNING_BODY"] = "COLLECTION_UPDATE_FORM_WARNING_BODY";
    T["COLLECTION_UPDATE_FORM_WARNING_TABLE_TITLE"] = "COLLECTION_UPDATE_FORM_WARNING_TABLE_TITLE";
    T["COLLECTION_UPDATE_FORM_PROCEED"] = "COLLECTION_UPDATE_FORM_PROCEED";
    T["COLLECTION_UPDATE_FORM_CANCEL"] = "COLLECTION_UPDATE_FORM_CANCEL";
    T["COLLECTION_REVISION_HISTORY"] = "COLLECTION_REVISION_HISTORY";
    T["COLLECTION_REVISION_HISTORY_ID"] = "COLLECTION_REVISION_HISTORY_ID";
    T["COLLECTION_REVISION_HISTORY_MODAL_TITLE"] = "COLLECTION_REVISION_HISTORY_MODAL_TITLE";
    T["COLLECTION_REVISION_HISTORY_MODAL_DESCRIPTION"] = "COLLECTION_REVISION_HISTORY_MODAL_DESCRIPTION";
    T["COLLECTION_REVISION_HISTORY_MODAL_REVERT"] = "COLLECTION_REVISION_HISTORY_MODAL_REVERT";
    T["COLLECTION_REVISION_HISTORY_MODAL_SUCCESS"] = "COLLECTION_REVISION_HISTORY_MODAL_SUCCESS";
    T["COLLECTION_REVISION_HISTORY_MODAL_FAILURE"] = "COLLECTION_REVISION_HISTORY_MODAL_FAILURE";
    T["COLLECTION_REVISION_HISTORY_REVERTED_MESSAGE"] = "COLLECTION_REVISION_HISTORY_REVERTED_MESSAGE";
    T["COLLECTION_REVISION_HISTORY_MOVED_FROM_DEPARTMENT_MESSAGE"] = "COLLECTION_REVISION_HISTORY_MOVED_FROM_DEPARTMENT_MESSAGE";
    T["COLLECTION_REVISION_HISTORY_FORM_MIGRATED_MESSAGE"] = "COLLECTION_REVISION_HISTORY_FORM_MIGRATED_MESSAGE";
    T["COLLECTION_REVISION_HISTORY_FORM_UPGRADED_MESSAGE"] = "COLLECTION_REVISION_HISTORY_FORM_UPGRADED_MESSAGE";
    T["COLLECTION_REVISION_HISTORY_SPAN_LINK_MESSAGE"] = "COLLECTION_REVISION_HISTORY_SPAN_LINK_MESSAGE";
    T["COLLECTION_INSIGHT_PROCESS"] = "COLLECTION_INSIGHT_PROCESS";
    T["COLLECTION_INSIGHT_PROCESS_CONFIRM"] = "COLLECTION_INSIGHT_PROCESS_CONFIRM";
    T["COLLECTION_INSIGHT_PROCESS_TITLE"] = "COLLECTION_INSIGHT_PROCESS_TITLE";
    T["COLLECTION_INSIGHT_PROCESS_SUCCESS"] = "COLLECTION_INSIGHT_PROCESS_SUCCESS";
    T["COLLECTION_INSIGHT_PROCESS_ERROR"] = "COLLECTION_INSIGHT_PROCESS_ERROR";
    T["COLLECTION_DELETE"] = "COLLECTION_DELETE";
    T["COLLECTION_DELETE_TITLE"] = "COLLECTION_DELETE_TITLE";
    T["COLLECTION_DELETE_CONFIRM"] = "COLLECTION_DELETE_CONFIRM";
    T["COLLECTION_DELETE_SUCCESS"] = "COLLECTION_DELETE_SUCCESS";
    T["COLLECTION_DELETE_BTN_TITLE"] = "COLLECTION_DELETE_BTN_TITLE";
    T["COLLECTION_DELETE_BTN_TITLE_DIRTY"] = "COLLECTION_DELETE_BTN_TITLE_DIRTY";
    T["COLLECTION_DELETE_REJECT"] = "COLLECTION_DELETE_REJECT";
    T["COLLECTION_EDIT"] = "COLLECTION_EDIT";
    T["COLLECTION_EDIT_ABORT"] = "COLLECTION_EDIT_ABORT";
    T["COLLECTION_EDIT_NO_CHANGES"] = "COLLECTION_EDIT_NO_CHANGES";
    T["COLLECTION_EDIT_SAVE_CHANGES"] = "COLLECTION_EDIT_SAVE_CHANGES";
    T["COLLECTION_EDIT_CREATE_SUBFORM"] = "COLLECTION_EDIT_CREATE_SUBFORM";
    T["COLLECTION_EDIT_DELETE_SUBFORM"] = "COLLECTION_EDIT_DELETE_SUBFORM";
    T["COLLECTION_EDIT_COPY_SUBFORM"] = "COLLECTION_EDIT_COPY_SUBFORM";
    T["COLLECTION_EDIT_COPY_SUBFORM_MEASUREMENTS"] = "COLLECTION_EDIT_COPY_SUBFORM_MEASUREMENTS";
    T["COLLECTION_EDIT_COPY_SUBFORM_SUCCESS"] = "COLLECTION_EDIT_COPY_SUBFORM_SUCCESS";
    T["COLLECTION_EDIT_COPY_SUBFORM_FAILURE"] = "COLLECTION_EDIT_COPY_SUBFORM_FAILURE";
    T["COLLECTION_EDIT_SAVE_ERROR"] = "COLLECTION_EDIT_SAVE_ERROR";
    T["COLLECTION_IMPORT_CHOOSE_FORM"] = "COLLECTION_IMPORT_CHOOSE_FORM";
    T["COLLECTION_IMPORT_FORM"] = "COLLECTION_IMPORT_FORM";
    T["COLLECTION_IMPORT_CHOOSE_JOB"] = "COLLECTION_IMPORT_CHOOSE_JOB";
    T["COLLECTION_IMPORT_JOB"] = "COLLECTION_IMPORT_JOB";
    T["COLLECTION_IMPORT_MAP_FIELDS"] = "COLLECTION_IMPORT_MAP_FIELDS";
    T["COLLECTION_IMPORT_CHOOSE_FILE_TYPE"] = "COLLECTION_IMPORT_CHOOSE_FILE_TYPE";
    T["COLLECTION_IMPORT_EXCEL_TEMPLATE"] = "COLLECTION_IMPORT_EXCEL_TEMPLATE";
    T["COLLECTION_IMPORT_EXCEL_USER_GUIDE"] = "COLLECTION_IMPORT_EXCEL_USER_GUIDE";
    T["COLLECTION_IMPORT_EXCEL_USER_GUIDE_LINK"] = "COLLECTION_IMPORT_EXCEL_USER_GUIDE_LINK";
    T["COLLECTION_IMPORT_FILE_CSV"] = "COLLECTION_IMPORT_FILE_CSV";
    T["COLLECTION_IMPORT_FILE_EXCEL"] = "COLLECTION_IMPORT_FILE_EXCEL";
    T["COLLECTION_IMPORT_TOO_MANY"] = "COLLECTION_IMPORT_TOO_MANY";
    T["COLLECTION_IMPORT_FAILED"] = "COLLECTION_IMPORT_FAILED";
    T["COLLECTION_IMPORT_SUCCESS"] = "COLLECTION_IMPORT_SUCCESS";
    T["COLLECTION_IMPORT_GO"] = "COLLECTION_IMPORT_GO";
    T["COLLECTION_IMPORT_CHOOSE_CSV_MAPPING"] = "COLLECTION_IMPORT_CHOOSE_CSV_MAPPING";
    T["COLLECTION_IMPORT_TITLE"] = "COLLECTION_IMPORT_TITLE";
    T["COLLECTION_IMPORT_FIELD_INVALID"] = "COLLECTION_IMPORT_FIELD_INVALID";
    T["COLLECTION_IMPORT_NOT_ALLOWED"] = "COLLECTION_IMPORT_NOT_ALLOWED";
    T["COLLECTION_IMPORT_PROGRESS"] = "COLLECTION_IMPORT_PROGRESS";
    T["COLLECTION_LINK"] = "COLLECTION_LINK";
    T["COLLECTION_LINK_START"] = "COLLECTION_LINK_START";
    T["COLLECTION_LINK_CANCEL"] = "COLLECTION_LINK_CANCEL";
    T["COLLECTION_LINK_INVALID"] = "COLLECTION_LINK_INVALID";
    T["DISCARD_CHANGES_TITLE"] = "DISCARD_CHANGES_TITLE";
    T["DISCARD_CHANGES_CONFIRM"] = "DISCARD_CHANGES_CONFIRM";
    T["DISCARD_CHANGES_DISCARD"] = "DISCARD_CHANGES_DISCARD";
    T["DISTANCE_MISSING"] = "DISTANCE_MISSING";
    T["DISTANCE_VERTICAL"] = "DISTANCE_VERTICAL";
    T["DISTANCE_HORIZONTAL"] = "DISTANCE_HORIZONTAL";
    T["DISTANCE_VECTOR"] = "DISTANCE_VECTOR";
    T["DISTANCE_SAG"] = "DISTANCE_SAG";
    T["DEPARTMENT_SELECTOR_TITLE"] = "DEPARTMENT_SELECTOR_TITLE";
    T["DEPARTMENT_SELECTOR_ACCEPT"] = "DEPARTMENT_SELECTOR_ACCEPT";
    T["DEPARTMENT_SELECTOR_SUCCESS"] = "DEPARTMENT_SELECTOR_SUCCESS";
    T["DEPARTMENT_SELECTOR_CURRENT"] = "DEPARTMENT_SELECTOR_CURRENT";
    T["DEPARTMENT_SELECTOR_DISABLED"] = "DEPARTMENT_SELECTOR_DISABLED";
    T["DEPARTMENT_SWITCH_EXPORT_IN_PROGRESS_TITLE"] = "DEPARTMENT_SWITCH_EXPORT_IN_PROGRESS_TITLE";
    T["DEPARTMENT_SWITCH_EXPORT_IN_PROGRESS_CONFIRM"] = "DEPARTMENT_SWITCH_EXPORT_IN_PROGRESS_CONFIRM";
    T["DEPARTMENT_SWITCH_PDF_EXPORT_IN_PROGRESS_CONFIRM"] = "DEPARTMENT_SWITCH_PDF_EXPORT_IN_PROGRESS_CONFIRM";
    T["DEPARTMENTS_DISABLED"] = "DEPARTMENTS_DISABLED";
    T["DISMISS"] = "DISMISS";
    T["INPUT_REQUIRED"] = "INPUT_REQUIRED";
    T["LINK_PHOTOMEASURE"] = "LINK_PHOTOMEASURE";
    T["LINK_MAP_WITH_COLLECTION"] = "LINK_MAP_WITH_COLLECTION";
    T["LINK_EDIT_TAG"] = "LINK_EDIT_TAG";
    T["LINK_COLLECTION_LIST"] = "LINK_COLLECTION_LIST";
    T["LINK_MAP_MODE"] = "LINK_MAP_MODE";
    /* Text shown after clicking the link button on a measurement */
    T["PHOTOMEASURE_JOIN"] = "PHOTOMEASURE_JOIN";
    T["PHOTOMEASURE_JOIN_START"] = "PHOTOMEASURE_JOIN_START";
    T["PHOTOMEASURE_LINK"] = "PHOTOMEASURE_LINK";
    T["PHOTOMEASURE_LINK_START"] = "PHOTOMEASURE_LINK_START";
    T["PHOTOMEASURE_DELETE_ALL_TITLE"] = "PHOTOMEASURE_DELETE_ALL_TITLE";
    T["PHOTOMEASURE_DELETE_ALL_TEXT"] = "PHOTOMEASURE_DELETE_ALL_TEXT";
    T["PHOTOMEASURE_HIDE_IMAGE_TITLE"] = "PHOTOMEASURE_HIDE_IMAGE_TITLE";
    T["PHOTOMEASURE_HIDE_IMAGE_TEXT"] = "PHOTOMEASURE_HIDE_IMAGE_TEXT";
    T["PHOTOMEASURE_UNHIDE_IMAGE_TITLE"] = "PHOTOMEASURE_UNHIDE_IMAGE_TITLE";
    T["PHOTOMEASURE_UNHIDE_IMAGE_TEXT"] = "PHOTOMEASURE_UNHIDE_IMAGE_TEXT";
    T["VERTICAL_SEPARATION_TOP"] = "VERTICAL_SEPARATION_TOP";
    T["VERTICAL_SEPARATION_BOTTOM"] = "VERTICAL_SEPARATION_BOTTOM";
    T["VERTICAL_SEPARATION_INVALID"] = "VERTICAL_SEPARATION_INVALID";
    T["BETA"] = "BETA";
    T["LEGACY"] = "LEGACY";
    T["EXPORT_MENU_TITLE"] = "EXPORT_MENU_TITLE";
    T["EXPORT_MENU_TITLE_DIRTY"] = "EXPORT_MENU_TITLE_DIRTY";
    T["EXPORT_MENU_TITLE_PERMISSION"] = "EXPORT_MENU_TITLE_PERMISSION";
    T["EXPORT_MENU_TITLE_LIMIT"] = "EXPORT_MENU_TITLE_LIMIT";
    T["EXPORTING_PDF_TITLE"] = "EXPORTING_PDF_TITLE";
    T["EXPORTING_PDF_CONTENT"] = "EXPORTING_PDF_CONTENT";
    T["EXPORT_KML"] = "EXPORT_KML";
    T["EXCEL"] = "EXCEL";
    T["IMPORTABLE_EXCEL"] = "IMPORTABLE_EXCEL";
    T["CSV"] = "CSV";
    T["EXPORT_JSON"] = "EXPORT_JSON";
    T["EXPORT_REPORT"] = "EXPORT_REPORT";
    T["EXPORT_REPORT_SHORT"] = "EXPORT_REPORT_SHORT";
    T["EXPORT_REPORT_COMPOSITE_PHOTO"] = "EXPORT_REPORT_COMPOSITE_PHOTO";
    T["EXPORT_REPORT_COMPOSITE_PHOTO_ONLY"] = "EXPORT_REPORT_COMPOSITE_PHOTO_ONLY";
    T["EXPORT_REPORT_PHOTO"] = "EXPORT_REPORT_PHOTO";
    T["EXPORT_SPIDA_CALC"] = "EXPORT_SPIDA_CALC";
    T["EXPORT_SPIDA_CALC_NO_PHOTO"] = "EXPORT_SPIDA_NO_PHOTO";
    T["EXPORT_O_CALC"] = "EXPORT_O_CALC";
    T["EXPORT_POLEFOREMAN"] = "EXPORT_POLEFOREMAN";
    T["EXPORT_IKE_POLEFOREMAN"] = "EXPORT_IKE_POLEFOREMAN";
    T["EXPORT_IMAGE_ZIP"] = "EXPORT_IMAGE_ZIP";
    T["EXPORT_DDS"] = "EXPORT_DDS";
    T["EXPORT_NOT_EVERYTHING_EXPORTED"] = "EXPORT_NOT_EVERYTHING_EXPORTED";
    T["EXPORT_DEPRECATED"] = "EXPORT_DEPRECATED";
    T["EXPORT_STARTED"] = "EXPORT_STARTED";
    T["EXPORT_MANAGER_TITLE"] = "EXPORT_MANAGER_TITLE";
    T["EXPORT_MANAGER_EMPTY"] = "EXPORT_MANAGER_EMPTY";
    T["EXPORT_MANAGER_CLEAR"] = "EXPORT_MANAGER_CLEAR";
    T["EXPORT_MANAGER_CLEAR_CONFIRM"] = "EXPORT_MANAGER_CLEAR_CONFIRM";
    T["EXPORT_MANAGER_NAVIGATE_AWAY"] = "EXPORT_MANAGER_NAVIGATE_AWAY";
    T["EXPORT_MANAGER_NAVIGATE_TITLE"] = "EXPORT_MANAGER_NAVIGATE_TITLE";
    T["EXPORT_MANAGER_STATUS_READY"] = "EXPORT_MANAGER_STATUS_READY";
    T["EXPORT_MANAGER_STATUS_DOWNLOADED"] = "EXPORT_MANAGER_STATUS_DOWNLOADED";
    T["EXPORT_MANAGER_STATUS_WARNING"] = "EXPORT_MANAGER_STATUS_WARNING";
    T["EXPORT_MANAGER_STATUS_ERROR"] = "EXPORT_MANAGER_STATUS_ERROR";
    T["EXPORT_MANAGER_STATUS_FAILED"] = "EXPORT_MANAGER_STATUS_FAILED";
    T["EXPORT_FINISHED"] = "EXPORT_FINISHED";
    T["EXPORT_FINISHED_WARNINGS"] = "EXPORT_FINISHED_WARNINGS";
    T["EXPORT_FINISHED_ERRORS"] = "EXPORT_FINISHED_ERRORS";
    T["FIELD_VECTOR_P2P_DISPLAY"] = "FIELD_VECTOR_DISPLAY";
    T["FILE_TOO_LARGE"] = "FILE_TOO_LARGE";
    T["FILE_DELETE"] = "FILE_DELETE";
    T["FILE_DELETE_TITLE"] = "FILE_DELETE_TITLE";
    T["FILE_DELETE_MESSAGE"] = "FILE_DELETE_MESSAGE";
    T["FILE_NOT_SUPPORTED"] = "FILE_NOT_SUPPORTED";
    T["FORM_TITLE"] = "FORM_TITLE";
    T["FORM_NAME"] = "FORM_NAME";
    T["FORM_DESCRIPTION"] = "FORM_DESCRIPTION";
    T["FORM_VERSION"] = "FORM_VERSION";
    T["FORM_UPDATED_AT"] = "FORM_UPDATED_AT";
    T["FORM_CREATED_AT"] = "FORM_CREATED_AT";
    T["FORM_EDIT"] = "FORM_EDIT";
    T["FORM_EDIT_TITLE"] = "FORM_EDIT_TITLE";
    T["FORM_CREATE"] = "FORM_CREATE";
    T["FORM_IMPORT"] = "FORM_IMPORT";
    T["FORM_IMPORT_POLEFOREMAN"] = "FORM_IMPORT_POLEFOREMAN";
    T["FORM_IMPORT_POLEFOREMAN_ERROR_DATABASE"] = "FORM_IMPORT_POLEFOREMAN_ERROR_DATABASE";
    T["FORM_IMPORT_POLEFOREMAN_OK"] = "FORM_IMPORT_POLEFOREMAN_OK";
    T["FORM_IMPORT_POLEFOREMAN_FETCHING_ORGS"] = "FORM_IMPORT_POLEFOREMAN_FETCHING_ORGS";
    T["FORM_IMPORT_POLEFOREMAN_SELECT_ORG"] = "FORM_IMPORT_POLEFOREMAN_SELECT_ORG";
    T["FORM_IMPORT_POLEFOREMAN_FETCHING_OP_CO"] = "FORM_IMPORT_POLEFOREMAN_FETCHING_OP_CO";
    T["FORM_IMPORT_POLEFOREMAN_ERROR_OP_CO"] = "FORM_IMPORT_POLEFOREMAN_ERROR_OP_CO";
    T["FORM_IMPORT_POLEFOREMAN_SINGLE_OP_CO"] = "FORM_IMPORT_POLEFOREMAN_SINGLE_OP_CO";
    T["FORM_IMPORT_POLEFOREMAN_SELECT_OP_CO"] = "FORM_IMPORT_POLEFOREMAN_SELECT_OP_CO";
    T["FORM_IMPORT_POLEFOREMAN_DESCRIPTION"] = "FORM_IMPORT_POLEFOREMAN_DESCRIPTION";
    T["FORM_IMPORT_POLEFOREMAN_OP_CO_DESCRIPTION"] = "FORM_IMPORT_POLEFOREMAN_OP_CO_DESCRIPTION";
    T["FORM_IMPORT_POLEFOREMAN_NO_DATABASES"] = "FORM_IMPORT_POLEFOREMAN_NO_DATABASES";
    T["FORM_IMPORT_POLEFOREMAN_NO_OPERATING_COMPANIES"] = "FORM_IMPORT_POLEFOREMAN_NO_OPERATING_COMPANIES";
    T["FORM_IMPORT_POLEFOREMAN_ERROR_CREATION"] = "FORM_IMPORT_POLEFOREMAN_ERROR_CREATION";
    T["FORM_IMPORT_UPLOAD_BUTTON"] = "FORM_IMPORT_UPLOAD_BUTTON";
    T["FORM_IMPORT_CONFIRM"] = "FORM_IMPORT_CONFIRM";
    T["FORM_IMPORT_SUCCEED"] = "FORM_IMPORT_SUCCEED";
    T["FORM_IMPORT_CHOOSE_FILE"] = "FORM_IMPORT_CHOOSE_FILE";
    T["FORM_NEW_POLEFOREMAN_FORM"] = "FORM_NEW_POLEFOREMAN_FORM";
    T["FORM_NEW_COPY_CUSTOM_FIELDS_FROM"] = "FORM_NEW_COPY_CUSTOM_FIELDS_FROM";
    T["FORM_PLA_SUPPORT"] = "FORM_PLA_SUPPORT";
    T["FORM_LIST_ADD"] = "FORM_LIST_ADD";
    T["FORM_FIELD_ADD_HIDE"] = "FORM_FIELD_ADD_HIDE";
    T["FORM_FIELD_MOVE_UP"] = "FORM_FIELD_MOVE_UP";
    T["FORM_FIELD_MOVE_DOWN"] = "FORM_FIELD_MOVE_DOWN";
    T["FORM_FIELD_DISPLAY_NAME"] = "FORM_FIELD_DISPLAY_NAME";
    T["FORM_FIELD_ANNOTATION_LABEL_FIELD_ID"] = "FORM_FIELD_ANNOTATION_LABEL_FIELD_ID";
    T["FORM_FIELD_TYPE"] = "FORM_FIELD_TYPE";
    T["FORM_FIELD_DESCRIPTION"] = "FORM_FIELD_DESCRIPTION";
    T["FORM_OPTION_CLONEABLE"] = "FORM_OPTION_CLONEABLE";
    T["FORM_OPTION_CLONEABLE_TITLE"] = "FORM_OPTION_CLONEABLE_TITLE";
    T["FORM_OPTION_LABEL"] = "FORM_OPTION_LABEL";
    T["FORM_OPTION_LABEL_TITLE"] = "FORM_OPTION_LABEL_TITLE";
    T["FORM_OPTION_SECONDARY_LABEL"] = "FORM_OPTION_SECONDARY_LABEL";
    T["FORM_OPTION_HIDE"] = "FORM_OPTION_HIDE";
    T["FORM_OPTION_HIDE_TITLE"] = "FORM_OPTION_HIDE_TITLE";
    T["FORM_OPTION_LOCKED"] = "FORM_OPTION_LOCKED";
    T["FORM_OPTION_STATUS"] = "FORM_OPTION_STATUS";
    T["FORM_OPTION_MAP_COLOR"] = "FORM_OPTION_MAP_COLOR";
    T["FORM_OPTION_REQUIRED"] = "FORM_OPTION_REQUIRED";
    T["FORM_OPTION_ADDRESS"] = "FORM_OPTION_ADDRESS";
    T["FORM_FIELD_CHOOSE"] = "FORM_FIELD_CHOOSE";
    T["FORM_FIELD_ADD"] = "FORM_FIELD_ADD";
    T["FORM_FIELD_CREATE"] = "FORM_FIELD_CREATE";
    T["FORM_FIELD_CANNOT_CHANGE"] = "FORM_FIELD_CANNOT_CHANGE";
    T["FORM_FIELD_DELETE"] = "FORM_FIELD_DELETE";
    T["FORM_FIELD_DELETE_TITLE"] = "FORM_FIELD_DELETE_TITLE";
    T["FORM_FIELD_DELETE_CONFIRM"] = "FORM_FIELD_DELETE_CONFIRM";
    T["FORM_FIELD_NESTED_LIST_DELETE"] = "FORM_FIELD_NESTED_LIST_DELETE";
    T["FORM_FIELD_NESTED_LIST_DELETE_TITLE"] = "FORM_FIELD_NESTED_LIST_DELETE_TITLE";
    T["FORM_FIELD_NESTED_LIST_DELETE_CONFIRM"] = "FORM_FIELD_NESTED_LIST_DELETE_CONFIRM";
    T["FORM_DELETE"] = "FORM_DELETE";
    T["FORM_DELETE_TITLE"] = "FORM_DELETE_TITLE";
    T["FORM_DELETE_CONFIRM"] = "FORM_DELETE_CONFIRM";
    T["FORM_DELETE_SUCCESS"] = "FORM_DELETE_SUCCESS";
    T["FORM_DUPLICATE"] = "FORM_DUPLICATE";
    T["FORM_COPY_TO_DEPARTMENT"] = "FORM_COPY_TO_DEPARTMENT";
    T["FORM_SHARE"] = "FORM_SHARE";
    T["FORM_SHARE_TITLE"] = "FORM_SHARE_TITLE";
    T["FORM_SHARE_CONFIRM"] = "FORM_SHARE_CONFIRM";
    T["FORM_SHARE_SUCCESS"] = "FORM_SHARE_SUCCESS";
    T["FORM_COPY_TO_DEPARTMENT_TITLE"] = "FORM_COPY_TO_DEPARTMENT_TITLE";
    T["FORM_COPY_TO_DEPARTMENT_CONFIRM"] = "FORM_COPY_TO_DEPARTMENT_CONFIRM";
    T["FORM_COPY_TO_DEPARTMENT_SUCCESS"] = "FORM_COPY_TO_DEPARTMENT_SUCCESS";
    T["FORM_COPY_TO_DEPARTMENT_DESCRIPTION"] = "FORM_COPY_TO_DEPARTMENT_DESCRIPTION";
    T["FORM_REFRESH"] = "FORM_REFRESH";
    T["FORM_REFRESH_MODAL_TITLE"] = "FORM_REFRESH_MODAL_TITLE";
    T["FORM_REFRESH_MODAL_TITLE_ERROR"] = "FORM_REFRESH_MODAL_TITLE_ERROR";
    T["FORM_REFRESH_MODAL_ERROR"] = "FORM_REFRESH_MODAL_ERROR";
    T["FORM_REFRESH_SUCCESS"] = "FORM_REFRESH_SUCCESS";
    T["FORM_NAME_MISSING"] = "FORM_NAME_MISSING";
    T["FORM_DESCRIPTION_MISSING"] = "FORM_DESCRIPTION_MISSING";
    T["FORM_ERROR_SAVING"] = "FORM_ERROR_SAVING";
    T["FORM_ERROR_DELETING"] = "FORM_ERROR_DELETING";
    T["FIELD_DISPLAY_NAME_MISSING"] = "FIELD_DISPLAY_NAME_MISSING";
    T["FIELD_TEXT"] = "FIELD_TEXT";
    T["FIELD_HEIGHT"] = "FIELD_HEIGHT";
    T["FIELD_NUMBER"] = "FIELD_NUMBER";
    T["FIELD_TRUE_SIZE"] = "FIELD_TRUE_SIZE";
    T["FIELD_DATE"] = "FIELD_DATE";
    T["FIELD_SELECT_LIST"] = "FIELD_SELECT_LIST";
    T["FIELD_YES_NO"] = "FIELD_YES_NO";
    T["FIELD_NESTED_LIST"] = "FIELD_NESTED_LIST";
    T["FIELD_NESTED_LIST_TITLE"] = "FIELD_NESTED_LIST_TITLE";
    T["FIELD_NESTED_LIST_VALUE"] = "FIELD_NESTED_LIST_VALUE";
    T["FIELD_FORM"] = "FIELD_FORM";
    T["FIELD_LOCATION"] = "FIELD_LOCATION";
    T["FIELD_LOCATION_ACCURACY"] = "FIELD_LOCATION_ACCURACY";
    T["FIELD_LOCATION_ALT"] = "FIELD_LOCATION_ALT";
    T["FIELD_LOCATION_ALT_IKE"] = "FIELD_LOCATION_ALT_IKE";
    T["FIELD_LOCATION_ALT_GROUND"] = "FIELD_LOCATION_ALT_GROUND";
    T["FIELD_LOCATION_ANTENNA_HEIGHT"] = "FIELD_LOCATION_ANTENNA_HEIGHT";
    T["FIELD_LOCATION_FIX"] = "FIELD_LOCATION_FIX";
    T["FIELD_LOCATION_FIX_DGPS"] = "FIELD_LOCATION_FIX_DGPS";
    T["FIELD_LOCATION_FIX_GPS"] = "FIELD_LOCATION_FIX_GPS";
    T["FIELD_LOCATION_FIX_PPS"] = "FIELD_LOCATION_FIX_PPS";
    T["FIELD_LOCATION_FIX_RTKFIXED"] = "FIELD_LOCATION_FIX_RTKFIXED";
    T["FIELD_LOCATION_FIX_RTKFLOAT"] = "FIELD_LOCATION_FIX_RTKFLOAT";
    T["FIELD_LOCATION_MANUAL"] = "FIELD_LOCATION_MANUAL";
    T["FIELD_LOCATION_EDITED"] = "FIELD_LOCATION_EDITED";
    T["FIELD_LOCATION_TRUESIZE"] = "FIELD_LOCATION_TRUESIZE";
    T["FIELD_LOCATION_GPS"] = "FIELD_LOCATION_GPS";
    T["FIELD_PROVIDER"] = "FIELD_PROVIDER";
    T["FIELD_IMAGE"] = "FIELD_IMAGE";
    T["FIELD_VECTOR"] = "FIELD_VECTOR";
    T["FIELD_ANCHOR"] = "FIELD_ANCHOR";
    T["FIELD_VECTOR_PROVIDER_MANUAL"] = "FIELD_VECTOR_PROVIDER_MANUAL";
    T["FIELD_VERTICAL_SEPARATION"] = "FIELD_VERTICAL_SEPARATION";
    T["FIELD_VERTICAL_SEPARATION_CLEARANCE"] = "FIELD_VERTICAL_SEPARATION_CLEARANCE";
    T["FIELD_FILE_TOOL"] = "FIELD_FILE_TOOL";
    T["FIELD_FILE_TOOL_FILE_SIZE"] = "FIELD_FILE_TOOL_FILE_SIZE";
    T["FORM_NOT_FOUND"] = "FORM_NOT_FOUND";
    T["SELECT_LIST_TITLE"] = "SELECT_LIST_TITLE";
    T["SELECT_LIST_VALUE"] = "SELECT_LIST_VALUE";
    T["ANCHOR_ALIGNMENT_INLINE"] = "ANCHOR_ALIGNMENT_INLINE";
    T["ANCHOR_ALIGNMENT_BISECT"] = "ANCHOR_ALIGNMENT_BISECT";
    T["ANCHOR_ALIGNMENT_OTHER"] = "ANCHOR_ALIGNMENT_OTHER";
    T["LIST_MAP"] = "LIST_MAP";
    T["LIST_JOB_LIST"] = "LIST_JOB_LIST";
    T["LIST_FORM_LIST"] = "LIST_FORM_LIST";
    T["LIST_USER_ACCOUNTS"] = "LIST_USER_ACCOUNTS";
    T["LIST_COLLECTION_IMPORT"] = "LIST_COLLECTION_IMPORT";
    T["LOGIN"] = "LOGIN";
    T["LOGOUT"] = "LOGOUT";
    T["LOGIN_WITH_AUTH0"] = "LOGIN_WITH_AUTH0";
    T["LOGIN_NO_AUTH0_ACCOUNT"] = "LOGIN_NO_AUTH0_ACCOUNT";
    T["UNABLE_TO_START_SSO_SERVICE"] = "UNABLE_TO_START_SSO_SERVICE";
    T["LOGIN_OFFICE"] = "LOGIN_OFFICE";
    T["SSO_MIGRATE_EMAIL_SENT"] = "SSO_MIGRATE_EMAIL_SENT";
    T["SSO_MIGRATE_EMAIL_EXISTING"] = "SSO_MIGRATE_EMAIL_EXISTING";
    T["SSO_MIGRATE_FAILED"] = "SSO_MIGRATE_FAILED";
    T["SSO_UPGRADE_ACCOUNT"] = "SSO_UPGRADE_ACCOUNT";
    T["PASSWORD_CHANGE_PASSWORD"] = "PASSWORD_CHANGE_PASSWORD";
    T["PASSWORD_CHANGE_PASSWORD_DETAIL"] = "PASSWORD_CHANGE_PASSWORD_DETAIL";
    T["PASSWORD_FORGOT_TITLE"] = "PASSWORD_FORGOT_TITLE";
    T["PASSWORD_FORGOT_EMAIL"] = "PASSWORD_FORGOT_EMAIL";
    T["PASSWORD_FORGOT_ACCEPT"] = "PASSWORD_FORGOT_ACCEPT";
    T["PASSWORD_RESET_EMAIL_SENT"] = "PASSWORD_RESET_EMAIL_SENT";
    T["PASSWORD_FORGOT_SUCCESS"] = "PASSWORD_FORGOT_SUCCESS";
    T["PLA_SPIDACALC"] = "PLA_SPIDACALC";
    T["PLA_OCALC"] = "PLA_OCALC";
    T["PLA_DDS"] = "PLA_DDS";
    T["PLA_POLEFOREMAN"] = "PLA_POLEFOREMAN";
    T["PLA_IKE_POLEFOREMAN"] = "PLA_IKE_POLEFOREMAN";
    T["SPAN_O_MATIC"] = "SPAN_O_MATIC";
    T["PRINT"] = "PRINT";
    T["ME"] = "ME";
    T["MISSING_404_CODE"] = "MISSING_404_CODE";
    T["MISSING_404_TITLE"] = "MISSING_404_TITLE";
    T["MISSING_404_BEFORE_LINK"] = "MISSING_404_BEFORE_LINK";
    T["MISSING_404_LINK"] = "MISSING_404_LINK";
    T["MISSING_404_AFTER_LINK"] = "MISSING_404_AFTER_LINK";
    T["MISSING_403_CODE"] = "MISSING_403_CODE";
    T["MISSING_403_TITLE"] = "MISSING_403_TITLE";
    T["MISSING_403_BEFORE_LINK"] = "MISSING_403_BEFORE_LINK";
    T["MISSING_403_LINK"] = "MISSING_403_LINK";
    T["MISSING_403_AFTER_LINK"] = "MISSING_403_AFTER_LINK";
    T["MISSING_PAGE_NA"] = "MISSING_PAGE_NA";
    T["MULTI_ORG_MAP"] = "MULTI_ORG_MAP";
    T["NAVIGATE_MAP"] = "NAVIGATE_MAP";
    T["NO_LOCATION"] = "NO_LOCATION";
    T["NO_CAPTURES"] = "NO_CAPTURES";
    T["SELECT_CAPTURE"] = "SELECT_CAPTURE";
    T["NOTIFICATION_IN"] = "NOTIFICATION_IN";
    T["NOTIFICATION_ERROR_TITLE"] = "NOTIFICATION_ERROR_TITLE";
    T["NOTIFICATION_WARNING_TITLE"] = "NOTIFICATION_WARNING_TITLE";
    T["NOTIFICATION_CODE_REQUIRED"] = "NOTIFICATION_CODE_REQUIRED";
    T["NOTIFICATION_CODE_DEFAULT"] = "NOTIFICATION_CODE_DEFAULT";
    T["NOTIFICATION_CODE_INVALID"] = "NOTIFICATION_CODE_INVALID";
    T["NOTIFICATION_CODE_UNKNOWN"] = "NOTIFICATION_CODE_UNKNOWN";
    T["NOTIFICATION_REASON_AGL"] = "NOTIFICATION_REASON_AGL";
    T["NOTIFICATION_REASON_NO_LOCATION"] = "NOTIFICATION_REASON_NO_LOCATION";
    T["NOTIFICATION_REASON_NO_GUY_WIRE"] = "NOTIFICATION_REASON_NO_GUY_WIRE";
    T["NOTIFICATION_REASON_CLIENT_ITEM"] = "NOTIFICATION_REASON_CLIENT_ITEM";
    T["NOTIFICATION_REASON_OTHER"] = "NOTIFICATION_REASON_OTHER";
    T["NOTIFICATION_REASON_ONLY"] = "NOTIFICATION_REASON_ONLY";
    T["NOTIFICATION_REASON_MISSING"] = "NOTIFICATION_REASON_MISSING";
    T["REASON_PLA_COUNT_ON_SPAN_MISMATCH"] = "REASON_PLA_COUNT_ON_SPAN_MISMATCH";
    T["REASON_PLA_COLLECTION_LINK_ONE_WAY"] = "REASON_PLA_COLLECTION_LINK_ONE_WAY";
    T["REASON_PLA_SPAN_SAME_TYPE_LINKED"] = "REASON_PLA_SPAN_SAME_TYPE_LINKED";
    T["REASON_PLA_MULTIPLE_SPANS_LINKED"] = "REASON_PLA_MULTIPLE_SPANS_LINKED";
    T["REASON_PLA_POWER_CIRCUIT_PHASE_HEIGHT_MISMATCH"] = "REASON_PLA_POWER_CIRCUIT_PHASE_HEIGHT_MISMATCH";
    T["REASON_IPF_ANCHOR_ASSEMBLY_TYPE_NOT_FOUND"] = "REASON_IPF_ANCHOR_ASSEMBLY_TYPE_NOT_FOUND";
    T["REASON_IPF_ANCHOR_LEAD_LENGTH_MISSING"] = "REASON_IPF_ANCHOR_LEAD_LENGTH_MISSING";
    T["REASON_IPF_ANCHOR_TOO_MANY_GUYS"] = "REASON_IPF_ANCHOR_TOO_MANY_GUYS";
    T["REASON_IPF_CONDUCTOR_TYPE_NOT_FOUND"] = "REASON_IPF_CONDUCTOR_TYPE_NOT_FOUND";
    T["REASON_IPF_CYCLE_DETECTED"] = "REASON_IPF_CYCLE_DETECTED";
    T["REASON_IPF_ISOLATED_POLES_DETECTED"] = "REASON_IPF_ISOLATED_POLES_DETECTED";
    T["REASON_IPF_EQUIPMENT_ATTACHMENT_HEIGHT_MISSING"] = "REASON_IPF_EQUIPMENT_ATTACHMENT_HEIGHT_MISSING";
    T["REASON_IPF_EQUIPMENT_ORIENTATION_MISSING"] = "REASON_IPF_EQUIPMENT_ORIENTATION_MISSING";
    T["REASON_IPF_EQUIPMENT_TYPE_NOT_FOUND"] = "REASON_IPF_EQUIPMENT_TYPE_NOT_FOUND";
    T["REASON_IPF_FRAMING_TYPE_NOT_FOUND"] = "REASON_IPF_FRAMING_TYPE_NOT_FOUND";
    T["REASON_IPF_GUY_ATTACHMENT_HEIGHT_MISSING"] = "REASON_IPF_GUY_ATTACHMENT_HEIGHT_MISSING";
    T["REASON_IPF_GUY_TYPE_NOT_FOUND"] = "REASON_IPF_GUY_TYPE_NOT_FOUND";
    T["REASON_IPF_GUY_INSULATOR_TYPE_NOT_FOUND"] = "REASON_IPF_GUY_INSULATOR_TYPE_NOT_FOUND";
    T["REASON_IPF_JOINT_USE_CABLE_TYPE_NOT_FOUND"] = "REASON_IPF_JOINT_USE_CABLE_TYPE_NOT_FOUND";
    T["REASON_IPF_MULTIPLE_SPANS_SAME_TYPE"] = "REASON_IPF_MULTIPLE_SPANS_SAME_TYPE";
    T["REASON_IPF_POWER_CIRCUIT_TYPE_NOT_FOUND"] = "REASON_IPF_POWER_CIRCUIT_TYPE_NOT_FOUND";
    T["REASON_IPF_SERVICE_CANNOT_BE_COLLECTION_LINKED"] = "REASON_IPF_SERVICE_CANNOT_BE_COLLECTION_LINKED";
    T["REASON_IPF_SERVICE_LENGTH_MISSING"] = "REASON_IPF_SERVICE_LENGTH_MISSING";
    T["REASON_IPF_SERVICE_ENDPOINT_MISSING"] = "REASON_IPF_SERVICE_ENDPOINT_MISSING";
    T["REASON_IPF_TARGET_COLLECTION_NOT_FOUND"] = "REASON_IPF_TARGET_COLLECTION_NOT_FOUND";
    T["REASON_IPF_SERVICE_MULTIPLE_POWER_CIRCUITS"] = "REASON_IPF_SERVICE_MULTIPLE_POWER_CIRCUITS";
    T["REASON_IPF_SERVICE_MULTIPLE_TELEPHONE_CABLES"] = "REASON_IPF_SERVICE_MULTIPLE_TELEPHONE_CABLES";
    T["REASON_IPF_SERVICE_MULTIPLE_CATV_CABLES"] = "REASON_IPF_SERVICE_MULTIPLE_CATV_CABLES";
    T["REASON_IPF_REQUIRED_FIELD"] = "REASON_IPF_REQUIRED_FIELD";
    T["REASON_IPF_POWER_CIRCUIT_NEEDS_GROUP"] = "REASON_IPF_POWER_CIRCUIT_NEEDS_GROUP";
    T["REASON_IPF_POWER_CIRCUIT_PRIMARY_PHASE_HEIGHT_MISSING"] = "REASON_IPF_POWER_CIRCUIT_PRIMARY_PHASE_HEIGHT_MISSING";
    T["REASON_IPF_POWER_CIRCUIT_SECONDARY_PHASE_HEIGHT_MISSING"] = "REASON_IPF_POWER_CIRCUIT_SECONDARY_PHASE_HEIGHT_MISSING";
    T["REASON_IPF_LOCATION_FALLBACK_TO_PHOTO"] = "REASON_IPF_LOCATION_FALLBACK_TO_PHOTO";
    T["REASON_IPF_SECONDARY_MULTIPLEX_MORE_THAN_1_ATTACHMENT_HEIGHT"] = "REASON_IPF_SECONDARY_MULTIPLEX_MORE_THAN_1_ATTACHMENT_HEIGHT";
    T["REASON_DDS_REQUIRED_FIELD"] = "REASON_DDS_REQUIRED_FIELD";
    T["REASON_DDS_RECOMMENDED_FIELD"] = "REASON_DDS_RECOMMENDED_FIELD";
    T["REASON_DDS_LOCATION_FALLBACK_TO_PHOTO"] = "REASON_DDS_LOCATION_FALLBACK_TO_PHOTO";
    T["REASON_DDS_EQUIPMENT_TYPE_NOT_FOUND"] = "REASON_DDS_EQUIPMENT_TYPE_NOT_FOUND";
    T["NUMBER_INVALID"] = "NUMBER_INVALID";
    T["NUMBER_IMPRECISE"] = "NUMBER_IMPRECISE";
    T["ORG_SEARCH"] = "ORG_SEARCH";
    T["UNKNOWN"] = "UNKNOWN";
    T["USER_MENU_FORM"] = "USER_MENU_FORM";
    T["USER_MENU_ACCOUNTS"] = "USER_MENU_ACCOUNTS";
    T["USER_MENU_SETTINGS"] = "USER_MENU_SETTINGS";
    T["USER_MENU_CHANGE_PASSWORD"] = "USER_MENU_CHANGE_PASSWORD";
    T["USER_MENU_LOGOUT"] = "USER_MENU_LOGOUT";
    T["REPORT_PRE_LOAD_TITLE"] = "REPORT_PRE_LOAD_TITLE";
    T["REPORT_PRE_LOAD_LOADING"] = "REPORT_PRE_LOAD_LOADING";
    T["REPORT_PRE_LOAD_INVALID_LICENSE"] = "REPORT_PRE_LOAD_INVALID_LICENSE";
    T["REPORT_COLLECTION_PLACE"] = "REPORT_COLLECTION_PLACE";
    T["REPORT_COLLECTION_VECTOR"] = "REPORT_COLLECTION_VECTOR";
    T["REPORT_COLLECTION_ANCHOR"] = "REPORT_COLLECTION_ANCHOR";
    T["REPORT_COLLECTION_LAT_LNG"] = "REPORT_COLLECTION_LAT_LNG";
    T["REPORT_COLLECTION_LAT_LNG_ALT"] = "REPORT_COLLECTION_LAT_LNG_ALT";
    T["ROLE_USER"] = "ROLE_USER";
    T["ROLE_ADMIN"] = "ROLE_ADMIN";
    T["ROLE_EDITOR"] = "ROLE_EDITOR";
    T["ROLE_DOWNLOADER"] = "ROLE_DOWNLOADER";
    T["ROLE_VIEWER"] = "ROLE_VIEWER";
    T["ROLE_DATA_ADMIN"] = "ROLE_DATA_ADMIN";
    T["SAVE"] = "SAVE";
    T["CLEAR_UNLOCKED_FIELDS"] = "CLEAR_UNLOCKED_FIELDS";
    T["CLEAR_ALL_FIELDS"] = "CLEAR_ALL_FIELDS";
    T["CLEAR_FIELDS_HELP"] = "CLEAR_FIELDS_HELP";
    T["SELECT"] = "SELECT";
    T["SELECT_OPTION"] = "SELECT_OPTION";
    T["SELECT_MEASUREMENT"] = "SELECT_MEASUREMENT";
    T["SETTINGS_TITLE"] = "SETTINGS_TITLE";
    T["SETTINGS_DATE_FORMAT"] = "SETTINGS_DATE_FORMAT";
    T["SETTINGS_UNITS"] = "SETTINGS_UNITS";
    T["SETTINGS_DONE"] = "SETTINGS_DONE";
    T["SETTINGS_SAVED"] = "SETTINGS_SAVED";
    T["SETTINGS_ERROR_SAVING"] = "SETTINGS_ERROR_SAVING";
    T["SIGNUP_EMAIL"] = "SIGNUP_EMAIL";
    T["SUBMIT"] = "SUBMIT";
    T["BACK_TO_LOGIN"] = "BACK_TO_LOGIN";
    T["SORT_TITLE"] = "SORT_TITLE";
    T["SORT_DESCENDING"] = "SORT_DESCENDING";
    T["SORT_ASCENDING"] = "SORT_ASCENDING";
    T["SORT_FIELD_COLLECTED_AT"] = "SORT_FIELD_COLLECTED_AT";
    T["SORT_FIELD_COLLECTED_BY"] = "SORT_FIELD_COLLECTED_BY";
    T["SORT_FIELD_UPDATED_AT"] = "SORT_FIELD_UPDATED_AT";
    T["SORT_FIELD_NAME"] = "SORT_FIELD_NAME";
    T["SORT_FIELD_STATUS"] = "SORT_FIELD_STATUS";
    T["SORT_FIELD_ASSIGNED"] = "SORT_FIELD_ASSIGNED";
    T["SPAN"] = "SPAN";
    T["SPAN_LINK_CANCEL"] = "SPAN_LINK_CANCEL";
    T["SPAN_LINK"] = "SPAN_LINK";
    T["SPAN_LINK_TITLE"] = "SPAN_LINK_TITLE";
    T["SPAN_LINK_SELECT_CONTENT"] = "SPAN_LINK_SELECT_CONTENT";
    T["SPAN_LINK_SUCCESS"] = "SPAN_LINK_SUCCESS";
    T["SPAN_LINK_NO_MATCH"] = "SPAN_LINK_NO_MATCH";
    T["SPAN_LINK_VERSION_MISMATCH"] = "SPAN_LINK_VERSION_MISMATCH";
    T["SPAN_LINK_MODAL_TITLE"] = "SPAN_LINK_MODAL_TITLE";
    T["SPAN_LINK_WARNING_TEXT"] = "SPAN_LINK_WARNING_TEXT";
    T["SPAN_LINK_CREATE_NEW"] = "SPAN_LINK_CREATE_NEW";
    T["SPAN_LINK_SELECT_SPAN"] = "SPAN_LINK_SELECT_SPAN";
    T["SPAN_LINK_SELECT_SPAN_TITLE"] = "SPAN_LINK_SELECT_SPAN_TITLE";
    T["SPAN_LINK_LEARN_MORE"] = "SPAN_LINK_LEARN_MORE";
    T["SPAN_LINK_NEW_SPAN_INFO"] = "SPAN_LINK_NEW_SPAN_INFO";
    T["SPAN_LINK_CONFIRM"] = "SPAN_LINK_CONFIRM";
    T["SPAN_LINK_DUPLICATE_ERROR"] = "SPAN_LINK_DUPLICATE_ERROR";
    T["SPAN_LINK_TWO_WAY_SUCCESS"] = "SPAN_LINK_TWO_WAY_SUCCESS";
    T["SPAN_LINK_ERROR"] = "SPAN_LINK_ERROR";
    T["SPAN_LINK_TARGET_SAVE_ERROR"] = "SPAN_LINK_TARGET_SAVE_ERROR";
    T["SPAN_UNLINK_CONFIRM_TITLE"] = "SPAN_UNLINK_CONFIRM_TITLE";
    T["SPAN_UNLINK_CONFIRM_MESSAGE"] = "SPAN_UNLINK_CONFIRM_MESSAGE";
    T["SPAN_UNLINK_CONFIRM_OK"] = "SPAN_UNLINK_CONFIRM_OK";
    T["SPAN_UNLINK_BOTH_SIDES"] = "SPAN_UNLINK_BOTH_SIDES";
    T["SPAN_VECTOR_FIELD"] = "SPAN_VECTOR_FIELD";
    T["SPAN_TYPE_FIELD"] = "SPAN_TYPE_FIELD";
    T["SPAN_MID_SPAN_IKE_PHOTO_FIELD"] = "SPAN_MID_SPAN_IKE_PHOTO_FIELD";
    T["SUBFORM_REMOVE_TITLE"] = "SUBFORM_REMOVE_TITLE";
    T["SUBFORM_REMOVE_CONFIRM"] = "SUBFORM_REMOVE_CONFIRM";
    T["SUBFORM_REMOVE_REMOVE"] = "SUBFORM_REMOVE_REMOVE";
    T["TOOL_BASE"] = "TOOL_BASE";
    T["TOOL_SELECT"] = "TOOL_SELECT";
    T["TOOL_HEIGHT"] = "TOOL_HEIGHT";
    T["TOOL_WIDTH"] = "TOOL_WIDTH";
    T["TOOL_ARRANGE_ANNOTATIONS"] = "TOOL_ARRANGE_ANNOTATIONS";
    T["TOOL_CABLE_MEASURE"] = "TOOL_CABLE_MEASURE";
    T["TOOL_CABLE_MEASURE_INCREASE"] = "TOOL_CABLE_MEASURE_INCREASE";
    T["TOOL_CABLE_MEASURE_DECREASE"] = "TOOL_CABLE_MEASURE_DECREASE";
    T["TOOL_ZOOM_IN"] = "TOOL_ZOOM_IN";
    T["TOOL_ZOOM_OUT"] = "TOOL_ZOOM_OUT";
    T["TOOL_ZOOM_RESET"] = "TOOL_ZOOM_RESET";
    T["TOOL_BRIGHTNESS_INCREASE"] = "TOOL_BRIGHTNESS_INCREASE";
    T["TOOL_BRIGHTNESS_DECREASE"] = "TOOL_BRIGHTNESS_DECREASE";
    T["TOOL_BRIGHTNESS_RESET"] = "TOOL_BRIGHTNESS_RESET";
    T["TOOL_LASER_TOGGLE"] = "TOOL_LASER_TOGGLE";
    T["TOOL_INFO_TOGGLE"] = "TOOL_INFO_TOGGLE";
    T["TOOL_MEASUREMENTS_CLEAR"] = "TOOL_MEASUREMENTS_CLEAR";
    T["TOOL_DATE_TOGGLE"] = "TOOL_DATE_TOGGLE";
    T["TOOL_BEARING_TOGGLE"] = "TOOL_BEARING_TOGGLE";
    T["TOOL_INSIGHT_DETECTIONS_TOGGLE_MARKERS"] = "TOOL_INSIGHT_DETECTIONS_TOGGLE_MARKERS";
    T["TOOL_INSIGHT_DETECTIONS_TOGGLE_MASKS"] = "TOOL_INSIGHT_DETECTIONS_TOGGLE_MASKS";
    T["TOOL_INSIGHT_DETECTIONS_MARKERS_NONE"] = "TOOL_INSIGHT_DETECTIONS_MARKERS_NONE";
    T["TOOL_INSIGHT_DETECTIONS_MASKS_NONE"] = "TOOL_INSIGHT_DETECTIONS_MASKS_NONE";
    T["TOPO_TOOL_RELOCATE_POLE"] = "TOPO_TOOL_RELOCATE_POLE";
    T["TOPO_TOOL_CREATE_POLE"] = "TOPO_TOOL_CREATE_POLE";
    T["TOPO_TOOL_SNAP"] = "TOPO_TOOL_SNAP";
    T["TOPO_TOOL_MEASURE"] = "TOPO_TOOL_MEASURE";
    T["TOPO_SAVE_JOB"] = "TOPO_SAVE_JOB";
    T["TOPO_SUCCESS_SAVE_JOB"] = "TOPO_SUCCESS_SAVE_JOB";
    T["TOPO_UNSAVED_COLLECTION"] = "TOPO_UNSAVED_COLLECTION";
    T["TOPO_SHOW_HIDE_LABELS"] = "TOPO_SHOW_HIDE_LABELS";
    T["TOPO_SHOW_CAROUSEL"] = "TOPO_SHOW_CAROUSEL";
    T["TOPO_SHOW_COLLECTION_DATA"] = "TOPO_SHOW_COLLECTION_DATA";
    T["TOPO_MUST_SAVE_FIRST"] = "TOPO_MUST_SAVE_FIRST";
    T["TOPO_MUST_SAVE_TARGET_FIRST"] = "TOPO_MUST_SAVE_TARGET_FIRST";
    T["MEASUREMENT_CLICK_TO_REMOVE"] = "MEASUREMENT_CLICK_TO_REMOVE";
    T["MAPMODE_LEGEND_DROPSPAN"] = "MAPMODE_LEGEND_DROPSPAN";
    T["MAPMODE_LEGEND_ANCHOR"] = "MAPMODE_LEGEND_ANCHOR";
    T["MAPMODE_LEGEND_SPAN"] = "MAPMODE_LEGEND_SPAN";
    T["MAPMODE_LEGEND_UNKNOWN"] = "MAPMODE_LEGEND_UNKNOWN";
    T["MAPMODE_LEGEND_COLLECTION_LABEL"] = "MAPMODE_LEGEND_COLLECTION_LABEL";
    T["MAPMODE_LEGEND_SELECTED_COLLECTION"] = "MAPMODE_LEGEND_SELECTED_COLLECTION";
    T["MAPMODE_LEGEND_LOCATION_RTK_FIXED"] = "MAPMODE_LEGEND_LOCATION_RTK_FIXED";
    T["MAPMODE_LEGEND_LOCATION_REVIEWED"] = "MAPMODE_LEGEND_LOCATION_REVIEWED";
    T["MAPMODE_LEGEND_LOCATION_RTK_FLOAT"] = "MAPMODE_LEGEND_LOCATION_RTK_FLOAT";
    T["MAPMODE_LEGEND_LOCATION_LOW_ACCURACY"] = "MAPMODE_LEGEND_LOCATION_LOW_ACCURACY";
    T["MEASUREMENT_EMPTY_STATE"] = "MEASUREMENT_EMPTY_STATE";
    T["MEASUREMENT_PAUSE_TOOLTIP"] = "MEASUREMENT_PAUSE_TOOLTIP";
    T["MEASUREMENT_RESUME_TOOLTIP"] = "MEASUREMENT_RESUME_TOOLTIP";
    T["MEASUREMENT_RULING_SPAN"] = "MEASUREMENT_RULING_SPAN";
    T["MEASUREMENT_TOTAL_DISTANCE"] = "MEASUREMENT_TOTAL_DISTANCE";
    T["UNIT_SHORT_FEET"] = "UNIT_SHORT_FEET";
    T["UNIT_SHORT_INCH"] = "UNIT_SHORT_INCH";
    T["UNIT_SHORT_METER"] = "UNIT_SHORT_METER";
    T["UNIT_SHORT_DEGREE"] = "UNIT_SHORT_DEGREE";
    T["UNIT_METER"] = "UNIT_METER";
    T["UNIT_FEET_INCH"] = "UNIT_FEET_INCH";
    T["USER_ASSIGN_REQUIRED"] = "USER_ASSIGN_REQUIRED";
    T["YES"] = "YES";
    T["NO"] = "NO";
    T["LAT"] = "LAT";
    T["LNG"] = "LNG";
    T["ERROR"] = "error";
    T["CREATED"] = "created";
    T["UPDATED"] = "updated";
    T["IMPORT_FAILED"] = "Import Failed";
    T["TOOL_CROP_SET"] = "TOOL_CROP_SET";
    T["COLLECTION_DUPLICATE_TITLE"] = "COLLECTION_DUPLICATE_TITLE";
    T["COLLECTION_DUPLICATE"] = "COLLECTION_DUPLICATE";
    T["COLLECTION_DUPLICATE_CONFIRM"] = "COLLECTION_DUPLICATE_CONFIRM";
    T["COLLECTION_DUPLICATE_SUCCESS"] = "COLLECTION_DUPLICATE_SUCCESS";
    T["FORM_OPTION_ADMIN_ONLY"] = "FORM_OPTION_ADMIN_ONLY";
    T["FORM_OPTION_ADMIN_ONLY_TITLE"] = "FORM_OPTION_ADMIN_ONLY_TITLE";
    T["FORM_OPTION_STATUS_TITLE"] = "FORM_OPTION_STATUS_TITLE";
    T["FORM_OPTION_MAP_COLOR_TITLE"] = "FORM_OPTION_MAP_COLOR_TITLE";
    T["FORM_OPTION_REQUIRED_TITLE"] = "FORM_OPTION_REQUIRED_TITLE";
    T["FORM_OPTION_ADDRESS_TITLE"] = "FORM_OPTION_ADDRESS_TITLE";
    T["FORM_OPTION_PRO_ONLY_TITLE"] = "FORM_OPTION_PRO_ONLY_TITLE";
    T["FILTER"] = "FILTER";
    T["MESSAGE_MOBILE_VALIDATION_TITLE"] = "MESSAGE_MOBILE_VALIDATION_TITLE";
    T["MESSAGE_MOBILE_VALIDATION_CONTENT"] = "MESSAGE_MOBILE_VALIDATION_CONTENT";
    T["MESSAGE_BROWSER_VALIDATION_TITLE"] = "MESSAGE_BROWSER_VALIDATION_TITLE";
    T["MESSAGE_BROWSER_VALIDATION_CONTENT"] = "MESSAGE_BROWSER_VALIDATION_CONTENT";
    T["MESSAGE_BROWSER_VALIDATION_URL"] = "MESSAGE_BROWSER_VALIDATION_URL";
    T["MESSAGE_BROWSER_VALIDATION_URL_TEXT"] = "MESSAGE_BROWSER_VALIDATION_URL_TEXT";
    T["LICENSE_CHECK_FAILED_TEXT"] = "LICENSE_CHECK_FAILED_TEXT";
    T["LICENSE_CHECK_FAILED_CONTACT_ADMIN_TEXT"] = "LICENSE_CHECK_FAILED_CONTACT_ADMIN_TEXT";
    T["LICENSE_CHECK_FAILED_CONTACT_ADMIN_EMAIL"] = "LICENSE_CHECK_FAILED_CONTACT_ADMIN_EMAIL";
    T["LICENSE_CHECK_FAILED_LINK"] = "LICENSE_CHECK_FAILED_LINK";
    T["REASON_SPIDA_CALC_TITLE_INVALID"] = "REASON_SPIDA_CALC_TITLE_INVALID";
    T["REASON_SPIDA_CALC_SPAN_LINKING_TARGET_POLE_NOT_FOUND"] = "REASON_SPIDA_CALC_SPAN_LINKING_TARGET_POLE_NOT_FOUND";
    T["REASON_SPIDA_CALC_SPAN_LINKING_SPAN_MISMATCH"] = "REASON_SPIDA_CALC_SPAN_LINKING_SPAN_MISMATCH";
    T["REASON_SPIDA_CALC_SPAN_LINKING_WIRES_COUNT_MISMATCH"] = "REASON_SPIDA_CALC_SPAN_LINKING_WIRES_COUNT_MISMATCH";
    T["REASON_SPIDA_CALC_SPAN_LINKING_WIRES_TOO_MANY"] = "REASON_SPIDA_CALC_SPAN_LINKING_WIRES_TOO_MANY";
    T["REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUYS_COUNT_MISMATCH"] = "REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUYS_COUNT_MISMATCH";
    T["REASON_SPIDA_CALC_SPAN_LINKING_WIRE_OWNER_MISMATCH"] = "REASON_SPIDA_CALC_SPAN_LINKING_WIRE_OWNER_MISMATCH";
    T["REASON_SPIDA_CALC_SPAN_LINKING_WIRE_USAGE_GROUP_MISMATCH"] = "REASON_SPIDA_CALC_SPAN_LINKING_WIRE_USAGE_GROUP_MISMATCH";
    T["REASON_SPIDA_CALC_SPAN_LINKING_WIRE_SIZE_MISMATCH"] = "REASON_SPIDA_CALC_SPAN_LINKING_WIRE_SIZE_MISMATCH";
    T["REASON_SPIDA_CALC_SPAN_LINKING_WIRE_TENSION_GROUP_MISMATCH"] = "REASON_SPIDA_CALC_SPAN_LINKING_WIRE_TENSION_GROUP_MISMATCH";
    T["REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_OWNER_MISMATCH"] = "REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_OWNER_MISMATCH";
    T["REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_USAGE_GROUP_MISMATCH"] = "REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_USAGE_GROUP_MISMATCH";
    T["REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_SIZE_MISMATCH"] = "REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_SIZE_MISMATCH";
    T["REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_TENSION_GROUP_MISMATCH"] = "REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_TENSION_GROUP_MISMATCH";
    T["REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_ATTACHMENT_HEIGHT_EXCEED_AGL"] = "REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_ATTACHMENT_HEIGHT_EXCEED_AGL";
    T["REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_MID_SPAN_HEIGHT_EXCEED_AGL"] = "REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_MID_SPAN_HEIGHT_EXCEED_AGL";
    T["REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_HEIGHT_EXCEED_AGL"] = "REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_HEIGHT_EXCEED_AGL";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_MULTIPLE_FORM_VERSIONS"] = "REASON_EXPORT_IMPORTABLE_EXCEL_MULTIPLE_FORM_VERSIONS";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_TOO_MANY_COLLECTIONS"] = "REASON_EXPORT_IMPORTABLE_EXCEL_TOO_MANY_COLLECTIONS";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_STRING"] = "REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_STRING";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LATITUDE"] = "REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LATITUDE";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LONGITUDE"] = "REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LONGITUDE";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_NUMBER"] = "REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_NUMBER";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_BOOLEAN"] = "REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_BOOLEAN";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_ANCHOR"] = "REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_ANCHOR";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LENGTH"] = "REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LENGTH";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LENGTH_IMPERIAL"] = "REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LENGTH_IMPERIAL";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_FORM_ID_MISMATCH"] = "REASON_EXPORT_IMPORTABLE_EXCEL_FORM_ID_MISMATCH";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_FORM_REVISION_MISMATCH"] = "REASON_EXPORT_IMPORTABLE_EXCEL_FORM_REVISION_MISMATCH";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_INVALID_DATE_FORMAT"] = "REASON_EXPORT_IMPORTABLE_EXCEL_INVALID_DATE_FORMAT";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_OPTION_DOES_NOT_EXIST"] = "REASON_EXPORT_IMPORTABLE_EXCEL_OPTION_DOES_NOT_EXIST";
    T["REASON_EXPORT_IMPORTABLE_EXCEL_USER_NOT_FOUND"] = "REASON_EXPORT_IMPORTABLE_EXCEL_USER_NOT_FOUND";
    T["IMPORT_FILE_NO_ROWS"] = "IMPORT_FILE_NO_ROWS";
    T["HELP_MENU"] = "HELP_MENU";
    T["SUBMIT_SUPPORT_REQUEST"] = "SUBMIT_SUPPORT_REQUEST";
    T["SUPPORT_PORTAL"] = "SUPPORT_PORTAL";
    T["RELEASE_NOTES"] = "RELEASE_NOTES";
    T["REVISION_ID"] = "REVISION_ID";
    T["MODIFIED_AT"] = "MODIFIED_AT";
    T["MODIFIED_BY"] = "MODIFIED_BY";
    T["MODIFICATIONS"] = "MODIFICATIONS";
})(T || (exports.T = T = {}));
exports.CURRENT_LANG = 'en-us';
exports.TRANSLATIONS = {
    'en-us': {
        [T.EMPTY]: '',
        [T.IKE_OFFICE]: 'IKE Office',
        [T.IKE_OFFICE_PRO]: 'IKE Office Pro',
        [T.ACCOUNT_LOCKED]: 'Your account has been locked due to multiple invalid login attempts. You can try again later or reset your password now.',
        [T.ACCOUNTS_TITLE]: 'Users',
        [T.ACCOUNTS_NAME]: 'Name',
        [T.ACCOUNTS_ROLE]: 'Role',
        [T.ACCOUNTS_INVITE]: 'Invite',
        [T.ACCOUNTS_INVITE_TITLE]: 'Invite New Users',
        [T.ACCOUNTS_INVITE_CONFIRM]: 'Email address to invite. Separate multiple email addresses with a comma.',
        [T.ACCOUNTS_INVITE_SUCCESS]: 'Invites Sent',
        [T.ACCOUNTS_INVITE_EXISTING_USER]: (usernames) => `Cannot invite existing users: ${usernames.join(',')}`,
        [T.ACCOUNTS_INVITE_INVALID_USER]: (usernames) => `Cannot invite invalid users: ${usernames.join(',')}`,
        [T.ACCOUNTS_INVITE_MAX]: (max) => `You can only make up to ${max} invites at one time.`,
        [T.ACCOUNTS_INVITE_CHOOSE_USER_ROLE]: 'Please choose user role',
        [T.ACCOUNTS_REMOVE]: 'Remove',
        [T.ACCOUNTS_REMOVE_TITLE]: 'Remove User',
        [T.ACCOUNTS_REMOVE_CONFIRM]: (username) => `Are you sure you would like to remove '${username}'?`,
        [T.ACCOUNTS_REMOVE_SUCCESS]: 'User Removed',
        [T.ACCOUNTS_SET_ROLE]: 'Set Role',
        [T.ACCOUNTS_SET_ROLE_TITLE]: 'Set User Role',
        [T.ACCOUNTS_SET_ROLE_CONFIRM]: ({ username, role }) => `Are you sure want to set ${username}'s role to ${role}?`,
        [T.ACCOUNTS_SET_ROLE_SUCCESS]: 'User has a new role',
        [T.BANNER_MESSAGE_PT1]: 'Having trouble logging in? Click ',
        [T.BANNER_MESSAGE_PT2]: ' for instructions on the new IKE ID',
        [T.OK]: 'Ok',
        [T.CANCEL]: 'Cancel',
        [T.NEXT]: 'Next',
        [T.CLOSE]: 'Close',
        [T.CONTINUE]: 'Continue',
        [T.HERE]: 'HERE',
        [T.SEND]: 'Send',
        [T.TRY_AGAIN]: 'Try again',
        [T.ACCEPT]: 'Accept',
        [T.COLOR]: 'Color',
        [T.ALTITUDE_MISSING]: 'Altitude missing',
        [T.LATITUDE_MISSING]: 'Latitude missing',
        [T.LONGITUDE_MISSING]: 'Longitude missing',
        [T.BEARING_INVALID]: 'Invalid bearing',
        [T.BEARING_MISSING]: 'Missing bearing',
        [T.PLACEMENT_MISSING]: 'Missing placement',
        [T.ACCURATE_ANCHOR_RELATED_SPAN_NO_VALUE]: 'The selected span(s) do not have a bearing specified',
        [T.ACCURATE_ANCHOR_RELATED_SPAN_NO_SELECTION_BISECT]: 'A bisect placement requires both spans to be selected',
        [T.ACCURATE_ANCHOR_RELATED_SPAN_NO_SELECTION_INLINE]: 'An inline placement requires a span to be select',
        [T.LOCATION_FIELD_OUT_OF_RANGE]: ({ field, maxValue }) => `${field} between -${maxValue} and ${maxValue} required`,
        [T.DATE_INVALID]: 'Invalid date',
        [T.DEPARTMENT]: 'Department',
        [T.EMAIL_INVALID]: 'Invalid Email',
        [T.EMAIL_EXISTS_IN_DEPARTMENT]: 'You are already logged in as a member.',
        [T.ENTER_VALID_EMAIL]: 'Please enter a valid email address',
        [T.USER_ALREADY_EXISTS_DESCRIPTION]: 'A user with this email address already exists. Try logging in.',
        [T.ERROR_GENERAL]: 'An error occurred',
        [T.ERROR_EXPORT]: 'There was an error exporting your collections',
        [T.ERROR_DOWNLOAD_FAIL]: 'Could not download file. Contact support.',
        [T.LOADING]: 'Loading...',
        [T.LOAD_MORE]: 'Load more',
        [T.LINK_PHOTOMEASURE]: 'PhotoMeasure collections',
        [T.LINK_COLLECTION_LIST]: 'Edit Collection List',
        [T.LINK_MAP_MODE]: 'Edit job in Map Based Review Mode',
        [T.LINK_EDIT_TAG]: 'Edit job name',
        [T.LINK_MAP_WITH_COLLECTION]: 'View collection details in the Big Map',
        [T.DRAWABLE_BASE_OFFSET]: 'Base offset',
        [T.DRAWABLE_TITLE]: 'Title',
        [T.STATUS]: 'Status',
        [T.NONE]: 'None',
        [T.TYPE]: 'Type',
        [T.DASHBOARD_POLE_LOADING]: 'Pole Loading',
        [T.DASHBOARD_POLE_STATUS]: 'Pole Status',
        [T.DASHBOARD]: 'Dashboard',
        [T.COLLECTION_TITLE]: 'Collections',
        [T.CLOSE_WINDOW]: 'Close Window',
        [T.COLLECTION_MISSING]: 'Collection not found',
        [T.COLLECTION_MISSING_TITLE]: 'No title',
        [T.COLLECTION_COLLECTED_AT]: 'Collected at',
        [T.COLLECTION_COLLECTED_BY]: 'Collected by',
        [T.COLLECTION_UPDATED_AT]: 'Last modified',
        [T.COLLECTION_UPDATED_BY]: 'Last modified by',
        [T.COLLECTION_ASSIGNED_TO]: 'Assigned to',
        [T.COLLECTION_FORM_NAME]: 'Form',
        [T.COLLECTION_FORM_VERSION]: 'Form version',
        [T.COLLECTION_EXPAND_ALL]: 'Expand all',
        [T.COLLECTION_COLLAPSE_ALL]: 'Collapse all',
        [T.COLLECTION_ASSIGN]: 'Assign',
        [T.COLLECTION_UNASSIGNED]: 'Unassigned',
        [T.COLLECTION_ASSIGN_TITLE]: 'Assign Collections',
        [T.COLLECTION_ASSIGN_CONFIRM]: ({ count }) => `Assign ${count} ${count === 1 ? 'collection' : 'collections'} to:`,
        [T.COLLECTION_ASSIGN_SUCCESS]: ({ count }) => `${count} ${count === 1 ? 'collection' : 'collections'} re-assigned`,
        [T.COLLECTION_MOVE]: 'Move',
        [T.COLLECTION_MOVE_TITLE]: 'Move Collections',
        [T.COLLECTION_MOVE_CONFIRM]: ({ count }) => `Move ${count} ${count === 1 ? 'collection' : 'collections'} to:`,
        [T.COLLECTION_MOVE_SUCCESS]: ({ count }) => `${count} ${count === 1 ? 'collection' : 'collections'} moved`,
        [T.COLLECTION_MOVE_JOB]: 'Move to Job',
        [T.COLLECTION_MOVE_JOB_TITLE]: 'Move Collections to Job',
        [T.COLLECTION_MOVE_JOB_INPUT_ERROR]: 'You need a Job name to move Collections to',
        [T.COLLECTION_MOVE_DEPARTMENT]: 'Move to Department',
        [T.COLLECTION_DUPLICATE]: 'Duplicate',
        [T.COLLECTION_DUPLICATE_TITLE]: 'Duplicate Collections',
        [T.COLLECTION_DUPLICATE_CONFIRM]: ({ count }) => `Are you sure you would like to duplicate ${count} ${count === 1 ? 'collection' : 'collections'}?`,
        [T.COLLECTION_DUPLICATE_SUCCESS]: ({ count }) => `${count} ${count === 1 ? 'collection' : 'collections'} duplicated`,
        [T.COLLECTION_STATUS]: 'Set Status',
        [T.CLEAR_COLLECTION_STATUS]: 'Clear Status',
        [T.COLLECTION_STATUS_TITLE]: 'Set Collection Status',
        [T.COLLECTION_STATUS_CONFIRM]: ({ count }) => `Set status for ${count} ${count === 1 ? 'collection' : 'collections'} to:`,
        [T.COLLECTION_STATUS_SUCCESS]: ({ count }) => `${count} ${count === 1 ? 'collection' : 'collections'} got new status`,
        [T.COLLECTION_STATUS_CANNOT_CHANGE]: ({ count }) => `Can't change: ${count}`,
        [T.COLLECTION_MIGRATE_FORM]: 'Migrate Form',
        [T.COLLECTION_MIGRATE_FORM_TITLE]: 'Form migration',
        [T.COLLECTION_MIGRATE_FORM_SUCCESS]: 'Successfully migrated collection forms',
        [T.COLLECTION_MIGRATE_FORM_FAIL]: 'Failed to migrate. Please try again later',
        [T.COLLECTION_MIGRATE_FORM_BODY_WARNING_TITLE]: 'WARNING: Data may be lost during Form migration',
        [T.COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT1]: "When migrating Forms, any data that doesn't have a matching field or matching value option in the target Form will be deleted.",
        [T.COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT2]: 'To prevent data loss:',
        [T.COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT3]: 'Consider duplicating your poles first to preserve all information, and only migrate one set of them.',
        [T.COLLECTION_MIGRATE_FORM_BODY_WARNING_DESCRIPTION_PT4]: "If needed, you can restore data using each pole's revision history, but note this can be time-consuming.",
        [T.COLLECTION_MIGRATE_FORM_BODY]: 'Choose a form to migrate the selected collections to:',
        [T.COLLECTION_MIGRATE_FORM_BODY_NO_FORMS]: 'No forms available for migration',
        [T.COLLECTION_UPDATE_FORM]: 'Update Form',
        [T.COLLECTION_UPDATE_FORM_TITLE]: 'Update Collection Form',
        [T.COLLECTION_UPDATE_FORM_CONFIRM]: ({ count }) => `Update form for ${count} ${count === 1 ? 'collection' : 'collections'}`,
        [T.COLLECTION_UPDATE_FORM_ERROR_TITLE]: ({ count }) => `Can't update the collections because of ${count} ${count === 1 ? 'error' : 'errors'}`,
        [T.COLLECTION_UPDATE_FORM_FIELD_MISSING]: 'Field is missing in new form',
        [T.COLLECTION_UPDATE_FORM_FIELD_VALUE_MISSING]: 'Field value is missing in new form',
        [T.COLLECTION_UPDATE_FORM_REASON]: 'Reason',
        [T.COLLECTION_UPDATE_FORM_VALUE]: 'Value',
        [T.COLLECTION_UPDATE_FORM_FIELD_NAME]: 'Field Name',
        [T.COLLECTION_UPDATE_FORM_SUCCESS]: 'Successfully updated forms.',
        [T.COLLECTION_UPDATE_FORM_CURRENT_REVISION]: 'Current Form Revision',
        [T.COLLECTION_UPDATE_FORM_LATEST_REVISION]: 'Latest Form Revision',
        [T.COLLECTION_UPDATE_FORM_ERROR]: 'Form update error',
        [T.COLLECTION_UPDATE_HAS_LATEST_FORM]: 'Latest form',
        [T.COLLECTION_UPDATE_FORM_WARNING_TITLE]: 'Warning: This form update will delete data.',
        [T.COLLECTION_UPDATE_FORM_WARNING_BODY]: "When updating Forms, any data that doesn't have a matching field or matching value option in the target Form will be deleted.",
        [T.COLLECTION_UPDATE_FORM_WARNING_TABLE_TITLE]: ({ count }) => `${count} ${count === 1 ? 'collection' : 'collections'} will lose data if you proceed`,
        [T.COLLECTION_UPDATE_FORM_PROCEED]: 'Update Form',
        [T.COLLECTION_UPDATE_FORM_CANCEL]: 'Cancel Update',
        [T.COLLECTION_REVISION_HISTORY]: 'Revision History',
        [T.COLLECTION_REVISION_HISTORY_ID]: (collectionName) => `Revision History: ${collectionName}`,
        [T.COLLECTION_REVISION_HISTORY_MODAL_TITLE]: ({ collectionName, revisionId }) => `Revert Collection ${collectionName} to revision ${revisionId}`,
        [T.COLLECTION_REVISION_HISTORY_MODAL_DESCRIPTION]: 'Are you sure you want to revert this collection?',
        [T.COLLECTION_REVISION_HISTORY_MODAL_REVERT]: 'Revert',
        [T.COLLECTION_REVISION_HISTORY_MODAL_SUCCESS]: 'Collection successfully reverted',
        [T.COLLECTION_REVISION_HISTORY_MODAL_FAILURE]: 'Collection revert failed',
        [T.COLLECTION_REVISION_HISTORY_REVERTED_MESSAGE]: (departmentName) => `Reverted to revision ${departmentName}`,
        [T.COLLECTION_REVISION_HISTORY_MOVED_FROM_DEPARTMENT_MESSAGE]: (collectionRevisionId) => `Moved from ${collectionRevisionId}`,
        [T.COLLECTION_REVISION_HISTORY_FORM_MIGRATED_MESSAGE]: ({ from, to }) => `Form migrated from ${from} to ${to}`,
        [T.COLLECTION_REVISION_HISTORY_FORM_UPGRADED_MESSAGE]: ({ title, from, to, }) => `Form updated from "${title}" V${from} to V${to}`,
        [T.COLLECTION_REVISION_HISTORY_SPAN_LINK_MESSAGE]: ({ poleTitle }) => `Span linked to "${poleTitle}"`,
        [T.COLLECTION_INSIGHT_PROCESS]: 'Run PolePilot',
        [T.COLLECTION_INSIGHT_PROCESS_TITLE]: 'Run PolePilot Processing',
        [T.COLLECTION_INSIGHT_PROCESS_CONFIRM]: (count) => `Please confirm that you would like to request PolePilot detections processing for the ${count} selected collection(s).\n
            If the department is correctly configured for processing PolePilot detections, these collections will be added to a queue for processing.\n
            Generally, detections should be available within 12 hours.`,
        [T.COLLECTION_INSIGHT_PROCESS_SUCCESS]: 'PolePilot processing requests sent!',
        [T.COLLECTION_INSIGHT_PROCESS_ERROR]: 'An error occurred while processing collections with PolePilot: ',
        [T.COLLECTION_DELETE]: 'Delete',
        [T.COLLECTION_DELETE_TITLE]: 'Delete Collections',
        [T.COLLECTION_DELETE_CONFIRM]: (count) => `Are you sure you would like to delete ${count} ${count === 1 ? 'collection' : 'collections'}?`,
        [T.COLLECTION_DELETE_SUCCESS]: ({ count }) => `${count} ${count === 1 ? 'collection' : 'collections'} deleted`,
        [T.COLLECTION_DELETE_BTN_TITLE]: 'Delete selected collections',
        [T.COLLECTION_DELETE_BTN_TITLE_DIRTY]: 'Please save your changes before deleting.',
        [T.COLLECTION_DELETE_REJECT]: ({ max }) => `Cannot delete more than ${max} jobs at once`,
        [T.COLLECTION_SHOW_META]: 'Show collection information',
        [T.COLLECTION_SHOW_ZOOM]: 'Show attachment preview',
        [T.COLLECTION_IMPORT_PROGRESS]: ({ count, total }) => `Importing ${count} of ${total}...`,
        [T.COLLECTION_LINK]: 'Collection Link',
        [T.COLLECTION_LINK_START]: 'Select a collection on the map to link to',
        [T.COLLECTION_LINK_CANCEL]: 'Cancel Collection Link',
        [T.COLLECTION_LINK_INVALID]: 'Cannot link to same collection',
        [T.COLLECTION_EDIT]: 'Edit collection',
        [T.COLLECTION_EDIT_ABORT]: 'Discard changes',
        [T.COLLECTION_EDIT_NO_CHANGES]: 'No changes',
        [T.COLLECTION_EDIT_SAVE_CHANGES]: 'Save changes',
        [T.COLLECTION_EDIT_CREATE_SUBFORM]: ({ title }) => `Add new ${title}`,
        [T.COLLECTION_EDIT_DELETE_SUBFORM]: ({ title }) => `Remove ${title}`,
        [T.COLLECTION_EDIT_COPY_SUBFORM]: ({ title }) => `Duplicate ${title}`,
        [T.COLLECTION_EDIT_COPY_SUBFORM_MEASUREMENTS]: ({ title }) => `Duplicate ${title} with measurements`,
        [T.COLLECTION_EDIT_COPY_SUBFORM_SUCCESS]: ({ title }) => `Copied ${title}`,
        [T.COLLECTION_EDIT_COPY_SUBFORM_FAILURE]: ({ title }) => `${title} failed to copy`,
        [T.COLLECTION_EDIT_SAVE_ERROR]: 'Failed to save collection',
        [T.COLLECTION_IMPORT_CHOOSE_FORM]: 'Choose a form to import into',
        [T.COLLECTION_IMPORT_FORM]: 'Form',
        [T.COLLECTION_IMPORT_CHOOSE_JOB]: 'Choose a job to import into',
        [T.COLLECTION_IMPORT_JOB]: 'Job',
        [T.COLLECTION_IMPORT_MAP_FIELDS]: 'Map your CSV fields into your form',
        [T.COLLECTION_IMPORT_CHOOSE_FILE_TYPE]: (fileType) => `Choose a ${fileType} file to import from`,
        [T.COLLECTION_IMPORT_EXCEL_TEMPLATE]: 'Download the template for importing with your chosen form',
        [T.COLLECTION_IMPORT_EXCEL_USER_GUIDE]: 'Learn more in our user guide on how to import your data',
        [T.COLLECTION_IMPORT_EXCEL_USER_GUIDE_LINK]: 'https://support.ikegps.com/hc/en-us/articles/28311181980557-IKE-Office-Pro-Bulk-Import-User-Guide',
        [T.COLLECTION_IMPORT_FILE_CSV]: 'CSV File',
        [T.COLLECTION_IMPORT_FILE_EXCEL]: 'Excel File',
        [T.COLLECTION_IMPORT_TOO_MANY]: ({ count, max }) => `Cannot import more than ${max} collections.`,
        [T.COLLECTION_IMPORT_FAILED]: 'Failed to import collections.',
        [T.COLLECTION_IMPORT_GO]: 'Import',
        [T.COLLECTION_IMPORT_CHOOSE_CSV_MAPPING]: 'Select CSV field',
        [T.COLLECTION_IMPORT_TITLE]: 'Import Collections',
        [T.COLLECTION_IMPORT_SUCCESS]: ({ count }) => `${count} ${count === 1 ? 'collection' : 'collections'} imported!`,
        [T.COLLECTION_IMPORT_FIELD_INVALID]: ({ field }) => `Field cannot be imported into ${field}`,
        [T.COLLECTION_IMPORT_NOT_ALLOWED]: 'You do not have the correct permissions to import collections.',
        [T.DISCARD_CHANGES_TITLE]: 'Discard changes',
        [T.DISCARD_CHANGES_CONFIRM]: 'Are you sure you want to discard unsaved changes?',
        [T.DISCARD_CHANGES_DISCARD]: 'Discard',
        [T.DISTANCE_MISSING]: 'Missing distance',
        [T.DISTANCE_HORIZONTAL]: 'Horizontal distance',
        [T.DISTANCE_VERTICAL]: 'Vertical distance',
        [T.DISTANCE_VECTOR]: 'Vector',
        [T.DISTANCE_SAG]: 'Sag',
        [T.DEPARTMENT_SELECTOR_TITLE]: 'Change Department',
        [T.DEPARTMENT_SELECTOR_ACCEPT]: 'Change',
        [T.DEPARTMENT_SELECTOR_SUCCESS]: 'Department changed',
        [T.DEPARTMENT_SELECTOR_CURRENT]: 'Current',
        [T.DEPARTMENT_SELECTOR_DISABLED]: 'Disabled',
        [T.DEPARTMENT_SWITCH_EXPORT_IN_PROGRESS_TITLE]: 'Change department?',
        [T.DEPARTMENT_SWITCH_PDF_EXPORT_IN_PROGRESS_CONFIRM]: 'You cannot change departments while there is an active IKE Report in progress.',
        [T.DEPARTMENT_SWITCH_EXPORT_IN_PROGRESS_CONFIRM]: 'Are you sure you want to change department? You currently have an export in progress.',
        [T.DEPARTMENTS_DISABLED]: 'Departments are disabled.',
        [T.DISMISS]: 'Dismiss',
        [T.INPUT_REQUIRED]: 'Value required',
        [T.LAST_UPDATED_AT]: ({ timeString }) => `Last modified at ${timeString}`,
        [T.SEARCH]: 'Search jobs and collections',
        [T.SEARCH_RES]: 'Search Results',
        [T.CLEAR_SEARCH]: 'Clear search',
        [T.SEARCH_ERROR]: 'Search query is too long',
        [T.TAG_TITLE]: 'Jobs',
        [T.TAG_NAME]: 'Job Name',
        [T.TAG_FILTER]: 'Filter Jobs',
        [T.TAG_FILTER__SEARCH_EMPTY]: 'No results found',
        [T.TAG_ZOOM]: 'Zoom to jobs',
        [T.TAG_EXISTS]: (name) => `'${name}' already exists.`,
        [T.TAG_MERGE_TITLE]: 'Rename job',
        [T.TAG_MERGE_CONFIRM]: ({ collectionCount, oldName, newName }) => `Are you sure you want to merge ${collectionCount} ${collectionCount > 1 ? 'collections' : 'collection'} from '${oldName}' into '${newName}'?`,
        [T.TAG_TITLE_SELECTION]: (count) => `${count} collection${count !== 1 ? 's' : ''} selected`,
        [T.TAG_PHOTO]: (plural) => `Tag Photo${plural ? 's' : ''}`,
        [T.BETA]: 'beta',
        [T.LEGACY]: 'legacy',
        [T.EXPORT_MENU_TITLE]: 'Export selected collections',
        [T.EXPORT_MENU_TITLE_DIRTY]: 'Please save your changes before exporting.',
        [T.EXPORT_MENU_TITLE_PERMISSION]: "You don't have the appropriate permissions.",
        [T.EXPORT_MENU_TITLE_LIMIT]: ({ limit }) => `Too many collections selected (max ${limit})`,
        [T.EXPORTING_PDF_TITLE]: 'Generating PDF export',
        [T.EXPORTING_PDF_CONTENT]: 'PDF export generation in progress...',
        [T.EXPORT_KML]: 'KML',
        [T.EXCEL]: 'EXCEL',
        [T.IMPORTABLE_EXCEL]: 'IMPORTABLE EXCEL',
        [T.CSV]: 'CSV',
        [T.EXPORT_JSON]: 'JSON',
        [T.EXPORT_REPORT]: 'IKE REPORT',
        [T.EXPORT_REPORT_SHORT]: 'IKE REPORT SHORT',
        [T.EXPORT_REPORT_COMPOSITE_PHOTO]: 'COMPOSITE PHOTO REPORT',
        [T.EXPORT_REPORT_COMPOSITE_PHOTO_ONLY]: 'ONLY COMPOSITE PHOTO REPORT',
        [T.EXPORT_REPORT_PHOTO]: 'PHOTO REPORT',
        [T.EXPORT_SPIDA_CALC]: 'SPIDACALC WITH PHOTOS',
        [T.EXPORT_SPIDA_CALC_NO_PHOTO]: 'SPIDACALC NO PHOTOS',
        [T.EXPORT_O_CALC]: 'OCALC',
        [T.EXPORT_POLEFOREMAN]: 'POLEFOREMAN',
        [T.EXPORT_IKE_POLEFOREMAN]: 'IKE POLEFOREMAN',
        [T.EXPORT_IMAGE_ZIP]: 'IMAGE ZIP',
        [T.EXPORT_DDS]: 'DISTRIBUTION DESIGN STUDIO (DDS) (BETA)',
        [T.EXPORT_NOT_EVERYTHING_EXPORTED]: 'Not all collections could be exported because no locations were provided',
        [T.EXPORT_DEPRECATED]: 'This export is going to be removed. If you experience problems, please contact support.',
        [T.EXPORT_STARTED]: ({ type, name }) => `Export started: ${type} - ${name}`,
        [T.EXPORT_MANAGER_TITLE]: 'Exports',
        [T.EXPORT_MANAGER_EMPTY]: 'No exports',
        [T.EXPORT_MANAGER_CLEAR]: 'Clear',
        [T.EXPORT_MANAGER_CLEAR_CONFIRM]: 'Some exports have not been downloaded or reviewed. Clear anyway?',
        [T.EXPORT_MANAGER_NAVIGATE_AWAY]: 'Page navigation is not available while an export is in progress.',
        [T.EXPORT_MANAGER_NAVIGATE_TITLE]: 'Export in progress',
        [T.EXPORT_MANAGER_STATUS_READY]: 'Ready',
        [T.EXPORT_MANAGER_STATUS_DOWNLOADED]: 'Downloaded',
        [T.EXPORT_MANAGER_STATUS_WARNING]: 'Warning',
        [T.EXPORT_MANAGER_STATUS_ERROR]: 'Error',
        [T.EXPORT_MANAGER_STATUS_FAILED]: 'Failed',
        [T.EXPORT_FINISHED]: ({ type, issue }) => `${type} export has finished${issue ? ` with ${issue}` : ''}`,
        [T.EXPORT_FINISHED_WARNINGS]: 'warnings',
        [T.EXPORT_FINISHED_ERRORS]: 'errors',
        [T.FIELD_VECTOR_P2P_DISPLAY]: ({ length, angle }) => `${length} at ${angle}`,
        [T.FORM_TITLE]: 'Forms',
        [T.FORM_NAME]: 'Name',
        [T.FORM_DESCRIPTION]: 'Description',
        [T.FORM_VERSION]: 'Current version',
        [T.FORM_UPDATED_AT]: 'Last Modified',
        [T.FORM_CREATED_AT]: 'Created',
        [T.FORM_EDIT]: 'Edit Form',
        [T.FORM_EDIT_TITLE]: 'Form Information',
        [T.FORM_CREATE]: 'Create Form',
        [T.FORM_IMPORT]: 'Import Form',
        [T.FORM_IMPORT_POLEFOREMAN]: 'Create IKE PoleForeman Form',
        [T.FORM_IMPORT_POLEFOREMAN_ERROR_DATABASE]: 'Error fetching IPF databases. Please try again later.',
        [T.FORM_IMPORT_POLEFOREMAN_OK]: 'Submit',
        [T.FORM_IMPORT_POLEFOREMAN_FETCHING_ORGS]: 'Fetching organizations...',
        [T.FORM_IMPORT_POLEFOREMAN_SELECT_ORG]: 'Select an organization',
        [T.FORM_IMPORT_POLEFOREMAN_FETCHING_OP_CO]: 'Fetching operating companies.\nThis may take a few moments...',
        [T.FORM_IMPORT_POLEFOREMAN_ERROR_OP_CO]: 'Error loading operating companies. Please try again later.',
        [T.FORM_IMPORT_POLEFOREMAN_SINGLE_OP_CO]: (opCo) => `Single operating company (${opCo}) found. Creating form...`,
        [T.FORM_IMPORT_POLEFOREMAN_SELECT_OP_CO]: 'Select an operating company',
        [T.FORM_IMPORT_POLEFOREMAN_DESCRIPTION]: "Pick an Organization's IKE PoleForeman database",
        [T.FORM_IMPORT_POLEFOREMAN_OP_CO_DESCRIPTION]: "Pick from one of the available Operating Companies within the selected organization's database",
        [T.FORM_IMPORT_POLEFOREMAN_NO_DATABASES]: 'You do not have access to any IKE PoleForeman databases. Please check with your IKE Access administrator or ikeGPS staff to configure access.',
        [T.FORM_IMPORT_POLEFOREMAN_NO_OPERATING_COMPANIES]: 'The selected database seems to be malformed and does not contain any operating companies. Please check with your IPF database administrator',
        [T.FORM_IMPORT_POLEFOREMAN_ERROR_CREATION]: 'Error creating IKE PoleForeman form. Please try again later.',
        [T.FORM_IMPORT_UPLOAD_BUTTON]: 'Click to upload',
        [T.FORM_IMPORT_CONFIRM]: 'Submit',
        [T.FORM_IMPORT_SUCCEED]: 'Form imported successfully!',
        [T.FORM_IMPORT_CHOOSE_FILE]: 'Choose a supported form file to import from',
        [T.FORM_NEW_POLEFOREMAN_FORM]: 'New IKE PoleForeman Form',
        [T.FORM_NEW_COPY_CUSTOM_FIELDS_FROM]: 'Copy custom fields from: ',
        [T.FORM_PLA_SUPPORT]: 'PLA Support',
        [T.FORM_LIST_ADD]: 'Add item',
        [T.FORM_FIELD_DISPLAY_NAME]: 'Display name',
        [T.FORM_FIELD_ANNOTATION_LABEL_FIELD_ID]: 'Annotation Label Field Id',
        [T.FORM_FIELD_DESCRIPTION]: 'Description',
        [T.FORM_FIELD_TYPE]: 'Field type',
        [T.FORM_FIELD_ADD_HIDE]: 'Hide create field',
        [T.FORM_FIELD_MOVE_UP]: 'Move field up',
        [T.FORM_FIELD_MOVE_DOWN]: 'Move field down',
        [T.FORM_OPTION_CLONEABLE]: 'Cloneable',
        [T.FORM_OPTION_CLONEABLE_TITLE]: 'Clone to new collection in IKE Field',
        [T.FORM_OPTION_LABEL]: 'Label',
        [T.FORM_OPTION_LABEL_TITLE]: ({ isRoot }) => `Label for each ${isRoot ? 'form' : 'subform'}`,
        [T.FORM_OPTION_SECONDARY_LABEL]: 'Secondary label',
        [T.FORM_OPTION_HIDE]: 'Hide',
        [T.FORM_OPTION_HIDE_TITLE]: 'Hide on IKE Field',
        [T.FORM_OPTION_ADMIN_ONLY]: 'Admin-only',
        [T.FORM_OPTION_ADMIN_ONLY_TITLE]: 'Make editable by admin users only',
        [T.FORM_OPTION_STATUS]: 'Status',
        [T.FORM_OPTION_STATUS_TITLE]: 'Use this field as the status',
        [T.FORM_OPTION_MAP_COLOR]: 'Map Color',
        [T.FORM_OPTION_MAP_COLOR_TITLE]: 'Use this field to set collection map colors',
        [T.FORM_OPTION_REQUIRED]: 'Required',
        [T.FORM_OPTION_REQUIRED_TITLE]: 'This field is required',
        [T.FORM_OPTION_ADDRESS]: 'Address',
        [T.FORM_OPTION_ADDRESS_TITLE]: 'Make this field an address lookup',
        [T.FORM_OPTION_PRO_ONLY_TITLE]: 'Editing this field is an IKE Office Pro only feature',
        [T.FORM_OPTION_LOCKED]: 'Locked for Base Form support',
        [T.FORM_FIELD_CHOOSE]: 'Select a field to add',
        [T.FORM_FIELD_ADD]: ({ name }) => `Add field to ${name || 'form'}`,
        [T.FORM_FIELD_CREATE]: 'Create Field',
        [T.FORM_FIELD_CANNOT_CHANGE]: 'Populated fields cannot be changed',
        [T.FORM_FIELD_DELETE]: 'Delete field',
        [T.FORM_FIELD_DELETE_TITLE]: 'Delete field',
        [T.FORM_FIELD_DELETE_CONFIRM]: ({ name }) => `Are you sure you want to delete field ${name}?`,
        [T.FORM_FIELD_NESTED_LIST_DELETE]: 'Delete value',
        [T.FORM_FIELD_NESTED_LIST_DELETE_TITLE]: 'Delete value',
        [T.FORM_FIELD_NESTED_LIST_DELETE_CONFIRM]: 'Are you sure you want to delete this value and all children?',
        [T.FORM_DELETE]: 'Delete',
        [T.FORM_DELETE_TITLE]: 'Delete Form',
        [T.FORM_DELETE_CONFIRM]: ({ name }) => `Are you sure you would like to delete form: ${name}?'`,
        [T.FORM_DELETE_SUCCESS]: ({ name }) => `Deleted ${name}`,
        [T.FORM_DUPLICATE]: 'Duplicate',
        [T.FORM_COPY_TO_DEPARTMENT]: 'Copy To Department',
        [T.FORM_SHARE]: 'Share To Department',
        [T.FORM_SHARE_TITLE]: 'Share Form',
        [T.FORM_SHARE_CONFIRM]: ({ name }) => `Share ${name}:`,
        [T.FORM_SHARE_SUCCESS]: ({ name }) => `Shared ${name}`,
        [T.FORM_COPY_TO_DEPARTMENT_TITLE]: () => 'Copy To Department',
        [T.FORM_COPY_TO_DEPARTMENT_CONFIRM]: ({ name }) => `Copy ${name}:`,
        [T.FORM_COPY_TO_DEPARTMENT_SUCCESS]: ({ name }) => `Copied ${name}`,
        [T.FORM_COPY_TO_DEPARTMENT_DESCRIPTION]: 'Duplicating the form will create a unique copy of the form.',
        [T.FORM_REFRESH]: 'Refresh Form',
        [T.FORM_REFRESH_MODAL_TITLE]: 'Form Refresh',
        [T.FORM_REFRESH_MODAL_TITLE_ERROR]: 'Form Refresh Error',
        [T.FORM_REFRESH_MODAL_ERROR]: ({ name }) => `An error occurred while refreshing ${name}:`,
        [T.FORM_REFRESH_SUCCESS]: ({ name }) => `Successfully Refreshed ${name}`,
        [T.FORM_NAME_MISSING]: 'Name missing',
        [T.FORM_DESCRIPTION_MISSING]: 'Description missing',
        [T.FORM_ERROR_SAVING]: 'Error saving form',
        [T.FORM_ERROR_DELETING]: 'Error deleting form',
        [T.FIELD_DISPLAY_NAME_MISSING]: 'Display Name is required',
        [T.FIELD_TEXT]: 'Text',
        [T.FIELD_HEIGHT]: 'Height',
        [T.FIELD_NUMBER]: 'Number',
        [T.FIELD_TRUE_SIZE]: 'Photo Measure',
        [T.FIELD_DATE]: 'Date',
        [T.FIELD_SELECT_LIST]: 'Select List',
        [T.FIELD_YES_NO]: 'Yes No',
        [T.FIELD_NESTED_LIST]: 'Nested List',
        [T.FIELD_NESTED_LIST_TITLE]: ({ level }) => `Level ${level} Title`,
        [T.FIELD_NESTED_LIST_VALUE]: 'Value',
        [T.FIELD_FORM]: 'Subform',
        [T.FIELD_LOCATION]: 'Location',
        [T.FIELD_LOCATION_ACCURACY]: 'Accuracy',
        [T.FIELD_LOCATION_ALT]: 'Altitude',
        [T.FIELD_LOCATION_ALT_IKE]: 'IKE Altitude',
        [T.FIELD_LOCATION_ALT_GROUND]: 'Ground Altitude',
        [T.FIELD_LOCATION_ANTENNA_HEIGHT]: 'Antenna Height',
        [T.FIELD_LOCATION_FIX]: 'GPS Fix',
        [T.FIELD_LOCATION_FIX_DGPS]: 'DGPS',
        [T.FIELD_LOCATION_FIX_GPS]: 'GPS',
        [T.FIELD_LOCATION_FIX_PPS]: 'PPS',
        [T.FIELD_LOCATION_FIX_RTKFIXED]: 'RTK Fix',
        [T.FIELD_LOCATION_FIX_RTKFLOAT]: 'RTK Float',
        [T.FIELD_LOCATION_MANUAL]: 'Manually imported location',
        [T.FIELD_LOCATION_EDITED]: 'Manually edited location',
        [T.FIELD_LOCATION_TRUESIZE]: 'Target location',
        [T.FIELD_LOCATION_GPS]: 'GPS location',
        [T.FIELD_PROVIDER]: 'Provider',
        [T.FIELD_IMAGE]: 'Image',
        [T.FIELD_VECTOR]: 'Vector',
        [T.FIELD_ANCHOR]: 'Anchor (Beta)',
        [T.FIELD_VECTOR_PROVIDER_MANUAL]: 'Manual',
        [T.FIELD_VERTICAL_SEPARATION]: 'Vertical separation',
        [T.FIELD_VERTICAL_SEPARATION_CLEARANCE]: 'Clearance Threshold (optional)',
        [T.FIELD_FILE_TOOL]: 'File tool',
        [T.FIELD_FILE_TOOL_FILE_SIZE]: 'File size',
        [T.FORM_NOT_FOUND]: 'Form not found.',
        [T.LIST_MAP]: 'Map',
        [T.LIST_JOB_LIST]: 'Jobs',
        [T.LIST_FORM_LIST]: 'Forms',
        [T.LIST_USER_ACCOUNTS]: 'Accounts',
        [T.LIST_COLLECTION_IMPORT]: 'Import',
        [T.LOGIN]: 'Login',
        [T.LOGOUT]: 'Logout',
        [T.LOGIN_WITH_AUTH0]: 'Login with IKE ID',
        [T.LOGIN_NO_AUTH0_ACCOUNT]: "I don't have an IKE ID account",
        [T.UNABLE_TO_START_SSO_SERVICE]: 'Unable to start IKE ID Service',
        [T.LOGIN_OFFICE]: 'Login to IKE Office',
        [T.FILE_NOT_SUPPORTED]: 'File type not supported.',
        [T.FILE_TOO_LARGE]: 'File is too large. Maximum size is 10 MB.',
        [T.FILE_DELETE]: 'Delete',
        [T.FILE_DELETE_TITLE]: 'Delete Uploaded File',
        [T.FILE_DELETE_MESSAGE]: (file) => `Do you want to delete ${file}?`,
        [T.ME]: 'me',
        [T.MISSING_404_CODE]: '404',
        [T.MISSING_404_TITLE]: 'Page not found',
        [T.MISSING_404_BEFORE_LINK]: 'Please go back to the ',
        [T.MISSING_404_LINK]: 'homepage',
        [T.MISSING_404_AFTER_LINK]: ' and start from there',
        [T.MISSING_403_CODE]: '403',
        [T.MISSING_403_TITLE]: 'Missing Permissions',
        [T.MISSING_403_BEFORE_LINK]: 'Please go back to the ',
        [T.MISSING_403_LINK]: 'map',
        [T.MISSING_403_AFTER_LINK]: ' and start from there',
        [T.MISSING_PAGE_NA]: 'is not yet available',
        [T.MULTI_ORG_MAP]: 'Multi-Org Map',
        [T.NAVIGATE_MAP]: 'Go to map',
        [T.NO_LOCATION]: 'no location',
        [T.NO_CAPTURES]: 'No images collected',
        [T.SELECT_CAPTURE]: 'Select a capture to view',
        [T.NOTIFICATION_IN]: (fieldName) => `in ${fieldName}`,
        [T.NOTIFICATION_ERROR_TITLE]: 'Export failed with errors',
        [T.NOTIFICATION_WARNING_TITLE]: 'Export completed with warnings',
        [T.NOTIFICATION_CODE_REQUIRED]: 'is missing',
        [T.NOTIFICATION_CODE_DEFAULT]: 'was defaulted',
        [T.NOTIFICATION_CODE_INVALID]: 'is invalid',
        [T.NOTIFICATION_CODE_UNKNOWN]: 'is invalid',
        [T.NOTIFICATION_REASON_AGL]: 'AGL is higher than pole height.',
        [T.NOTIFICATION_REASON_NO_LOCATION]: 'No location.',
        [T.NOTIFICATION_REASON_NO_GUY_WIRE]: 'Missing guy wire.',
        [T.NOTIFICATION_REASON_CLIENT_ITEM]: (item) => `Missing ${item} from catalogue.`,
        [T.NOTIFICATION_REASON_OTHER]: (item) => item,
        [T.NOTIFICATION_REASON_ONLY]: (item) => item,
        [T.NOTIFICATION_REASON_MISSING]: (item) => item,
        [T.REASON_PLA_COUNT_ON_SPAN_MISMATCH]: ({ selfCount, otherCount, type }) => `Number of (${type}) on this span (${selfCount}) must equal the number of (${type}) on the connected span (${otherCount})`,
        [T.REASON_PLA_COLLECTION_LINK_ONE_WAY]: ({ poleCollectionTitle, targetCollectionTitle }) => `The pole "${poleCollectionTitle}" needs to be collection linked to "${targetCollectionTitle}" to enable span connectivity`,
        [T.REASON_PLA_SPAN_SAME_TYPE_LINKED]: ({ linkedPole, type }) => `Link to pole: ${linkedPole} uses spans of the same type: '${formatIpfSpanType(type)}'. One span must be changed to '${core_shared_1.IPF_SPAN_TYPES.filter((x) => x !== type)
            .map(formatIpfSpanType)
            .join("' or '")}'`,
        [T.REASON_PLA_MULTIPLE_SPANS_LINKED]: ({ poleCollectionTitle, targetCollectionTitle }) => `Multiple Spans are linked between '${poleCollectionTitle !== null && poleCollectionTitle !== void 0 ? poleCollectionTitle : 'No title'}' and '${targetCollectionTitle !== null && targetCollectionTitle !== void 0 ? targetCollectionTitle : 'No title'}' when there can only be one. One of the spans will be used for this export`,
        [T.REASON_PLA_POWER_CIRCUIT_PHASE_HEIGHT_MISMATCH]: ({ phase, linkedPole, missingSideTitle, populatedSideTitle }) => `${phase} height mismatch with connected Pole '${linkedPole}'. Value is set on Pole '${populatedSideTitle}' but is missing on Pole '${missingSideTitle}'.`,
        [T.REASON_IPF_ANCHOR_ASSEMBLY_TYPE_NOT_FOUND]: ({ displayDescription }) => `Anchor Assembly Type "${displayDescription}" was not found in the IPF database.`,
        [T.REASON_IPF_ANCHOR_LEAD_LENGTH_MISSING]: 'Anchor Lead Length is missing. Defaulting to 0.',
        [T.REASON_IPF_ANCHOR_TOO_MANY_GUYS]: 'Anchor has too many guy wires. The maximum is 3',
        [T.REASON_IPF_CONDUCTOR_TYPE_NOT_FOUND]: ({ displayDescription, rulingSpan }) => `Conductor Type "${displayDescription} -> ${rulingSpan}" was not found in the IPF database`,
        [T.REASON_IPF_CYCLE_DETECTED]: 'Cycle Detected -- This pole creates a collection linked loop, which IKE PoleForeman does not support.',
        [T.REASON_IPF_ISOLATED_POLES_DETECTED]: 'Isolated Poles Detected -- All collections need to be collection linked in order to enable span connectivity',
        [T.REASON_IPF_EQUIPMENT_ATTACHMENT_HEIGHT_MISSING]: 'Equipment Attachment Height is missing. Defaulting to 0 meters.',
        [T.REASON_IPF_EQUIPMENT_ORIENTATION_MISSING]: 'Equipment Orientation is missing. Defaulting to 0 degrees.',
        [T.REASON_IPF_EQUIPMENT_TYPE_NOT_FOUND]: ({ equipmentType, displayDescription }) => `Equipment Type "${equipmentType} -> ${displayDescription}" was not found in the IPF database.`,
        [T.REASON_IPF_FRAMING_TYPE_NOT_FOUND]: ({ displayDescription }) => `Framing Type "${displayDescription}" was not found in the IPF database.`,
        [T.REASON_IPF_GUY_ATTACHMENT_HEIGHT_MISSING]: 'Guy Attachment Height is missing. Defaulting to 0',
        [T.REASON_IPF_GUY_TYPE_NOT_FOUND]: ({ displayDescription }) => `Guy Size ${displayDescription} was not found in the IPF database.`,
        [T.REASON_IPF_GUY_INSULATOR_TYPE_NOT_FOUND]: 'Guy Insulator Type was not found in the IPF database.',
        [T.REASON_IPF_JOINT_USE_CABLE_TYPE_NOT_FOUND]: ({ displayDescription, rulingSpan }) => `Joint Use Cable Type "${displayDescription} -> ${rulingSpan}" was not found in the IPF database.`,
        [T.REASON_IPF_MULTIPLE_SPANS_SAME_TYPE]: ({ poleCollectionTitle }) => `The pole "${poleCollectionTitle}" has multiple linked spans of the same type. Only one type is allowed`,
        [T.REASON_IPF_POWER_CIRCUIT_TYPE_NOT_FOUND]: ({ displayDescription }) => `Power Circuit Type ${displayDescription} was not found in the IPF database`,
        [T.REASON_IPF_SERVICE_CANNOT_BE_COLLECTION_LINKED]: 'Service can not be collection linked',
        [T.REASON_IPF_SERVICE_LENGTH_MISSING]: 'Service Length is missing',
        [T.REASON_IPF_SERVICE_ENDPOINT_MISSING]: 'Service Endpoint Height is missing, Defaulting to Height of Attachment.',
        [T.REASON_IPF_SERVICE_MULTIPLE_POWER_CIRCUITS]: 'Multiple power subforms found in a single Service subform which is not supported',
        [T.REASON_IPF_SERVICE_MULTIPLE_TELEPHONE_CABLES]: 'Multiple telephone cables found in a single Service subform which is not supported',
        [T.REASON_IPF_SERVICE_MULTIPLE_CATV_CABLES]: 'Multiple CATV cables found in a single Service subform which is not supported',
        [T.REASON_IPF_REQUIRED_FIELD]: 'This field is required by IKE PoleForeman',
        [T.REASON_IPF_POWER_CIRCUIT_NEEDS_GROUP]: 'At least one Conductor and Framing must be set for Primary, Neutral, Secondary, or Shield',
        [T.REASON_IPF_POWER_CIRCUIT_PRIMARY_PHASE_HEIGHT_MISSING]: 'At least one of the Primary Phase Heights (A, B, or C) must be set',
        [T.REASON_IPF_POWER_CIRCUIT_SECONDARY_PHASE_HEIGHT_MISSING]: 'At least one of the Secondary Phase Heights (A, B, or C) must be set',
        [T.REASON_IPF_LOCATION_FALLBACK_TO_PHOTO]: 'The pole does not have a Location set, the elevation from the first captured IKE Photo will be used instead. Elevation can greatly impact PLA in IKE PoleForeman, so please make corrections as needed.',
        [T.REASON_IPF_TARGET_COLLECTION_NOT_FOUND]: `Linked collection is not a part of the export. Creating a Stand-In pole instead`,
        [T.REASON_IPF_SECONDARY_MULTIPLEX_MORE_THAN_1_ATTACHMENT_HEIGHT]: 'There can only be a single associated attachment height on a Secondary Multiplex conductor. Used first attachment height found.',
        [T.REASON_DDS_REQUIRED_FIELD]: 'This field is required by DDS',
        [T.REASON_DDS_RECOMMENDED_FIELD]: 'This field is recommended by DDS',
        [T.REASON_DDS_LOCATION_FALLBACK_TO_PHOTO]: 'The pole does not have a Location set, the elevation from the first captured IKE Photo will be used instead.',
        [T.REASON_DDS_EQUIPMENT_TYPE_NOT_FOUND]: ({ equipmentType, displayDescription }) => `Equipment Type "${equipmentType} -> ${displayDescription}" was not found in the DDS catalogue.`,
        [T.NUMBER_INVALID]: 'Number invalid',
        [T.NUMBER_IMPRECISE]: ({ minimumInputPrecision }) => `${minimumInputPrecision} decimals or higher precision required`,
        [T.ORG_SEARCH]: 'Organization Wide Search',
        [T.UNKNOWN]: 'Unknown',
        [T.PHOTOMEASURE_JOIN]: 'Measurement will be linked to opposing span',
        [T.PHOTOMEASURE_JOIN_START]: (title) => `Measurement will link to: ${title}`,
        [T.PHOTOMEASURE_LINK]: 'Cancel Measure',
        [T.PHOTOMEASURE_LINK_START]: 'Measure Height',
        [T.PHOTOMEASURE_DELETE_ALL_TITLE]: 'Delete all measurements',
        [T.PHOTOMEASURE_DELETE_ALL_TEXT]: 'Are you sure you want to delete all of the measurements from the image?',
        [T.PHOTOMEASURE_HIDE_IMAGE_TITLE]: 'Hide image',
        [T.PHOTOMEASURE_HIDE_IMAGE_TEXT]: 'Are you sure you want to hide the image?',
        [T.PHOTOMEASURE_UNHIDE_IMAGE_TITLE]: 'Unhide image',
        [T.PHOTOMEASURE_UNHIDE_IMAGE_TEXT]: 'Are you sure you want to unhide the image?',
        [T.VERTICAL_SEPARATION_TOP]: 'Top',
        [T.VERTICAL_SEPARATION_BOTTOM]: 'Bottom',
        [T.VERTICAL_SEPARATION_INVALID]: 'Select a bottom height for vertical separation measurement',
        [T.USER_MENU_FORM]: 'Form List',
        [T.USER_MENU_ACCOUNTS]: 'Accounts',
        [T.USER_MENU_SETTINGS]: 'User Settings',
        [T.USER_MENU_CHANGE_PASSWORD]: 'Change Password',
        [T.USER_MENU_LOGOUT]: 'Logout',
        [T.PASSWORD_CHANGE_PASSWORD]: 'Change Password',
        [T.PASSWORD_CHANGE_PASSWORD_DETAIL]: 'Are you sure you would like to change your password? You will receive a reset email which will be valid for 24 hours.',
        [T.PASSWORD_FORGOT_TITLE]: 'Reset password',
        [T.PASSWORD_FORGOT_EMAIL]: 'Email',
        [T.PASSWORD_FORGOT_ACCEPT]: 'Send reset email',
        [T.PASSWORD_RESET_EMAIL_SENT]: 'You have been sent a password reset email and will now be logged out.',
        [T.PASSWORD_FORGOT_SUCCESS]: 'A reset password link has been sent to you via email.',
        [T.PLA_SPIDACALC]: 'SPIDAcalc',
        [T.PLA_OCALC]: 'O-Calc',
        [T.PLA_DDS]: 'DDS',
        [T.PLA_POLEFOREMAN]: 'Legacy PoleForeman',
        [T.PLA_IKE_POLEFOREMAN]: 'IKE PoleForeman',
        [T.SPAN_O_MATIC]: 'Span-o-matic',
        [T.PRINT]: 'Print',
        [T.REPORT_PRE_LOAD_TITLE]: 'Exportable Reports',
        [T.REPORT_PRE_LOAD_LOADING]: 'Loading Report...',
        [T.REPORT_PRE_LOAD_INVALID_LICENSE]: 'You do not have a valid license to perform this action',
        [T.REPORT_COLLECTION_PLACE]: ({ index, of }) => `${index} of ${of}`,
        [T.REPORT_COLLECTION_VECTOR]: ({ distance, bearing }) => `${distance} at ${bearing}`,
        [T.REPORT_COLLECTION_ANCHOR]: ({ distance, bearing }) => `${distance} at ${bearing}`,
        [T.REPORT_COLLECTION_LAT_LNG]: ({ lat, lng }) => `(lat: ${lat}, lng: ${lng})`,
        [T.REPORT_COLLECTION_LAT_LNG_ALT]: ({ lat, lng, alt }) => `(lat: ${lat}, lng: ${lng}, alt: ${alt})`,
        [T.ROLE_USER]: 'User',
        [T.ROLE_ADMIN]: 'Admin',
        [T.ROLE_EDITOR]: 'Editor',
        [T.ROLE_DOWNLOADER]: 'Downloader',
        [T.ROLE_VIEWER]: 'Viewer',
        [T.ROLE_DATA_ADMIN]: 'Data Admin',
        [T.SAVE]: 'Save',
        [T.CLEAR_UNLOCKED_FIELDS]: 'Clear Unlocked Fields',
        [T.CLEAR_ALL_FIELDS]: 'Clear All Fields',
        [T.CLEAR_FIELDS_HELP]: 'Need help with removing locked fields? Subbmit a ticket',
        [T.SELECT]: (value) => `Select ${value}`,
        [T.SELECT_OPTION]: 'Select an option',
        [T.SELECT_MEASUREMENT]: 'Select attachment point to zoom',
        [T.SETTINGS_DATE_FORMAT]: 'Date Format',
        [T.SETTINGS_TITLE]: 'Change settings',
        [T.SETTINGS_UNITS]: 'Measurement Units',
        [T.SETTINGS_DONE]: 'Done',
        [T.SETTINGS_SAVED]: 'Settings saved...',
        [T.SETTINGS_ERROR_SAVING]: 'Error saving settings.',
        [T.SIGNUP_EMAIL]: 'Email',
        [T.SUBMIT]: 'Submit',
        [T.BACK_TO_LOGIN]: 'Back to login',
        [T.SSO_MIGRATE_EMAIL_SENT]: `Success! We've sent instructions on how to set a password for your new IKE ID to your inbox.`,
        [T.SSO_MIGRATE_EMAIL_EXISTING]: `Success! You can now login with the button below.`,
        [T.SSO_MIGRATE_FAILED]: `We couldn't find an IKE Office account for this email address, or this account has already been upgraded. Please contact customer support if you continue to experience issues trying to upgrade to an IKE ID.`,
        [T.SSO_UPGRADE_ACCOUNT]: 'Upgrade your IKE Office account',
        [T.SELECT_LIST_TITLE]: 'Text',
        [T.SELECT_LIST_VALUE]: 'Value',
        [T.ANCHOR_ALIGNMENT_INLINE]: 'Inline',
        [T.ANCHOR_ALIGNMENT_BISECT]: 'Bisect',
        [T.ANCHOR_ALIGNMENT_OTHER]: 'Other',
        [T.ACCURATE_ANCHOR_RELATED_SPAN_TITLE]: (label) => `Related Span ${label}`,
        [T.SORT_ASCENDING]: 'Ascending',
        [T.SORT_DESCENDING]: 'Descending',
        [T.SORT_TITLE]: 'Sort collections',
        [T.SORT_FIELD_COLLECTED_AT]: 'Collected at',
        [T.SORT_FIELD_COLLECTED_BY]: 'Collected by',
        [T.SORT_FIELD_UPDATED_AT]: 'Last Modified',
        [T.SORT_FIELD_NAME]: 'Title',
        [T.SORT_FIELD_STATUS]: 'Status',
        [T.SORT_FIELD_ASSIGNED]: 'Assigned to',
        [T.SPAN]: 'Span',
        [T.SPAN_LINK_CANCEL]: 'Cancel Span Link',
        [T.SPAN_LINK]: 'Span Link',
        [T.SPAN_LINK_TITLE]: 'Copy from existing Span',
        [T.SPAN_LINK_SELECT_CONTENT]: 'Select an existing span',
        [T.SPAN_LINK_SUCCESS]: ({ toSpan, fromCollection }) => `Created ${toSpan} from ${fromCollection}`,
        [T.SPAN_LINK_NO_MATCH]: 'No existing spans found near by',
        [T.SPAN_LINK_VERSION_MISMATCH]: 'Form versions differ between poles. Creating one-way span link.',
        [T.SPAN_LINK_MODAL_TITLE]: 'Select Span Link',
        [T.SPAN_LINK_WARNING_TEXT]: 'Note: Selecting an existing span will overwrite its data',
        [T.SPAN_LINK_CREATE_NEW]: 'Create new span',
        [T.SPAN_LINK_SELECT_SPAN]: 'Select a span to preview',
        [T.SPAN_LINK_SELECT_SPAN_TITLE]: 'Select an existing span or create a new one',
        [T.SPAN_LINK_LEARN_MORE]: 'Learn more about how span linking works',
        [T.SPAN_LINK_NEW_SPAN_INFO]: 'A new span will be created and linked',
        [T.SPAN_LINK_CONFIRM]: 'Link Span',
        [T.SPAN_LINK_DUPLICATE_ERROR]: ({ existingSpan }) => existingSpan
            ? `A span link to this pole already exists in "${existingSpan}"`
            : 'A span link to this pole already exists',
        [T.SPAN_LINK_TWO_WAY_SUCCESS]: 'Two-way span link created successfully',
        [T.SPAN_LINK_ERROR]: 'Failed to create span link',
        [T.SPAN_LINK_TARGET_SAVE_ERROR]: 'Failed to save linked pole. Please retry.',
        [T.SPAN_UNLINK_CONFIRM_TITLE]: 'Unlink Span',
        [T.SPAN_UNLINK_CONFIRM_MESSAGE]: ({ targetTitle }) => `This will also unlink the corresponding span on "${targetTitle}". Continue?`,
        [T.SPAN_UNLINK_CONFIRM_OK]: 'Unlink',
        [T.SPAN_UNLINK_BOTH_SIDES]: ({ targetTitle }) => `Span will be unlinked on both sides. Save to apply changes to "${targetTitle}".`,
        [T.SPAN_VECTOR_FIELD]: 'Span Vector Field',
        [T.SPAN_TYPE_FIELD]: 'Span Type Field',
        [T.SPAN_MID_SPAN_IKE_PHOTO_FIELD]: 'Mid Span IKE Photo Field',
        [T.SUBFORM_REMOVE_TITLE]: ({ title }) => `Remove ${title}`,
        [T.SUBFORM_REMOVE_CONFIRM]: ({ title }) => `Are you sure you want to remove this ${title}?`,
        [T.SUBFORM_REMOVE_REMOVE]: 'Remove',
        [T.TOOL_BASE]: 'Please select the base',
        [T.TOOL_SELECT]: 'Select',
        [T.TOOL_HEIGHT]: 'Height Marker',
        [T.TOOL_WIDTH]: 'Width Marker',
        [T.TOOL_CABLE_MEASURE]: 'Cable Measure',
        [T.TOOL_CABLE_MEASURE_INCREASE]: 'Increase cable size',
        [T.TOOL_CABLE_MEASURE_DECREASE]: 'Decrease cable size',
        [T.TOOL_ZOOM_IN]: 'Zoom in',
        [T.TOOL_ZOOM_OUT]: 'Zoom out',
        [T.TOOL_ZOOM_RESET]: 'Reset zoom',
        [T.TOOL_CROP_SET]: 'Set print area',
        [T.TOOL_BRIGHTNESS_INCREASE]: 'Increase brightness',
        [T.TOOL_BRIGHTNESS_DECREASE]: 'Decrease brightness',
        [T.TOOL_BRIGHTNESS_RESET]: 'Reset brightness',
        [T.TOOL_LASER_TOGGLE]: 'Laser Target',
        [T.TOOL_INFO_TOGGLE]: 'Show Info',
        [T.TOOL_MEASUREMENTS_CLEAR]: 'Delete all',
        [T.TOOL_DATE_TOGGLE]: 'Capture date',
        [T.TOOL_BEARING_TOGGLE]: 'Capture bearing',
        [T.TOOL_INSIGHT_DETECTIONS_TOGGLE_MARKERS]: 'Show/hide IKE Insight generated annotations',
        [T.TOOL_INSIGHT_DETECTIONS_TOGGLE_MASKS]: 'Show/hide IKE Insight generated masks',
        [T.TOOL_INSIGHT_DETECTIONS_MARKERS_NONE]: 'No IKE Insight annotations available',
        [T.TOOL_INSIGHT_DETECTIONS_MASKS_NONE]: 'No IKE Insight masks available',
        [T.TOOL_ARRANGE_ANNOTATIONS]: 'Arrange annotations',
        [T.TOPO_TOOL_RELOCATE_POLE]: 'Adjust pole location',
        [T.TOPO_TOOL_CREATE_POLE]: 'Add new pole',
        [T.TOPO_TOOL_SNAP]: 'Universal snapping',
        [T.TOPO_TOOL_MEASURE]: 'Measure ruling span',
        [T.TOPO_SAVE_JOB]: 'Save full job',
        [T.TOPO_SUCCESS_SAVE_JOB]: ({ amount }) => `Saved ${amount} collections`,
        [T.TOPO_UNSAVED_COLLECTION]: 'unsaved',
        [T.TOPO_SHOW_HIDE_LABELS]: 'Show/hide labels ─ Ctrl + L',
        [T.TOPO_SHOW_CAROUSEL]: 'Show image carousel',
        [T.TOPO_SHOW_COLLECTION_DATA]: 'Show collection data',
        [T.TOPO_MUST_SAVE_FIRST]: 'Must save collection before linking',
        [T.TOPO_MUST_SAVE_TARGET_FIRST]: 'You must save that collection before linking',
        [T.MEASUREMENT_CLICK_TO_REMOVE]: 'Click to remove',
        [T.MAPMODE_LEGEND_DROPSPAN]: 'Drop span',
        [T.MAPMODE_LEGEND_ANCHOR]: 'Anchor',
        [T.MAPMODE_LEGEND_SPAN]: 'Span',
        [T.MAPMODE_LEGEND_UNKNOWN]: 'Unknown',
        [T.MAPMODE_LEGEND_COLLECTION_LABEL]: 'Collection Label',
        [T.MAPMODE_LEGEND_SELECTED_COLLECTION]: 'Selected Collection',
        [T.MAPMODE_LEGEND_LOCATION_RTK_FIXED]: 'Location RTK Fixed',
        [T.MAPMODE_LEGEND_LOCATION_REVIEWED]: 'Location Reviewed',
        [T.MAPMODE_LEGEND_LOCATION_RTK_FLOAT]: 'Location RTK Float / Manual',
        [T.MAPMODE_LEGEND_LOCATION_LOW_ACCURACY]: 'Location Lower Accuracy',
        [T.MEASUREMENT_EMPTY_STATE]: 'Click on the map to start measuring',
        [T.MEASUREMENT_PAUSE_TOOLTIP]: 'Pause adding points',
        [T.MEASUREMENT_RESUME_TOOLTIP]: 'Resume adding points',
        [T.MEASUREMENT_RULING_SPAN]: 'Ruling Span:',
        [T.MEASUREMENT_TOTAL_DISTANCE]: 'Total Distance:',
        [T.UNIT_SHORT_FEET]: 'ft',
        [T.UNIT_SHORT_INCH]: 'in',
        [T.UNIT_SHORT_METER]: 'm',
        [T.UNIT_SHORT_DEGREE]: 'deg',
        [T.UNIT_FEET_INCH]: 'Feet/Inches',
        [T.UNIT_METER]: 'Meters',
        [T.USER_ASSIGN_REQUIRED]: 'Choose a user',
        [T.YES]: 'Yes',
        [T.NO]: 'No',
        [T.LAT]: 'Latitude',
        [T.LNG]: 'Longitude',
        [T.ERROR]: 'error',
        [T.CREATED]: 'created',
        [T.UPDATED]: 'updated',
        [T.IMPORT_FAILED]: 'Import Failed',
        [T.FILTER]: 'Search list entries',
        [T.MESSAGE_MOBILE_VALIDATION_TITLE]: 'IKE Office on Mobile',
        [T.MESSAGE_MOBILE_VALIDATION_CONTENT]: 'IKE Office is not optimized for mobile use.',
        [T.MESSAGE_BROWSER_VALIDATION_TITLE]: 'IKE Office Browser Compatibility',
        [T.MESSAGE_BROWSER_VALIDATION_CONTENT]: 'Your browser is not fully supported for use with IKE Office. For more information please see ',
        [T.MESSAGE_BROWSER_VALIDATION_URL]: 'https://ikegps.com/support/ike-office-supported-browsers/',
        [T.MESSAGE_BROWSER_VALIDATION_URL_TEXT]: 'Supported Browsers',
        [T.LICENSE_CHECK_FAILED_TEXT]: 'You do not have a license to perform this action. Licenses are managed in IKE Access, learn about license management ',
        [T.LICENSE_CHECK_FAILED_LINK]: 'here',
        [T.LICENSE_CHECK_FAILED_CONTACT_ADMIN_TEXT]: 'Need help contacting your license admin? Reach out to ',
        [T.LICENSE_CHECK_FAILED_CONTACT_ADMIN_EMAIL]: 'support@ikegps.com',
        [T.REASON_SPIDA_CALC_TITLE_INVALID]: ({ displayDescription }) => `Pole id is invalid due to ${displayDescription}`,
        [T.REASON_SPIDA_CALC_SPAN_LINKING_TARGET_POLE_NOT_FOUND]: 'The target pole is not found in the export',
        [T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_MISMATCH]: 'Only "Fore Span" and "Back Span" linking is valid. This span and its contents will need to be manually linked in SPIDAcalc',
        [T.REASON_SPIDA_CALC_SPAN_LINKING_WIRES_COUNT_MISMATCH]: 'The wire count does not match its linked span wire count. This span and its contents will need to be manually linked in SPIDAcalc',
        [T.REASON_SPIDA_CALC_SPAN_LINKING_WIRES_TOO_MANY]: 'There are too many wire subforms with this attachment height. The maximum number is 2',
        [T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUYS_COUNT_MISMATCH]: 'The span-guy count does not match its linked span span-guy count. This span and its contents will need to be manually linked in SPIDAcalc',
        [T.REASON_SPIDA_CALC_SPAN_LINKING_WIRE_USAGE_GROUP_MISMATCH]: 'The wire usage group does not match its linked wire usage group. The parent span and its contents will need to be manually linked in SPIDAcalc',
        [T.REASON_SPIDA_CALC_SPAN_LINKING_WIRE_SIZE_MISMATCH]: 'The wire size does not match its linked wire size. The parent span and its contents will need to be manually linked in SPIDAcalc',
        [T.REASON_SPIDA_CALC_SPAN_LINKING_WIRE_TENSION_GROUP_MISMATCH]: 'The wire tension group does not match its linked wire tension group. The parent span and its contents will need to be manually linked in SPIDAcalc',
        [T.REASON_SPIDA_CALC_SPAN_LINKING_WIRE_OWNER_MISMATCH]: 'The wire owner does not match its linked wire owner. The parent span and its contents will need to be manually linked in SPIDAcalc',
        [T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_USAGE_GROUP_MISMATCH]: 'The span-guy usage group does not match its linked span-guy usage group. The parent span and its contents will need to be manually linked in SPIDAcalc',
        [T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_SIZE_MISMATCH]: 'The span-guy size does not match its linked span-guy size. The parent span and its contents will need to be manually linked in SPIDAcalc',
        [T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_TENSION_GROUP_MISMATCH]: 'The span-guy tension group does not match its span-guy tension group. The parent span and its contents will need to be manually linked in SPIDAcalc',
        [T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_OWNER_MISMATCH]: 'The span-guy owner does not match its linked span-guy owner. The parent span and its contents will need to be manually linked in SPIDAcalc',
        [T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_ATTACHMENT_HEIGHT_EXCEED_AGL]: 'The span-guy attachment height exceeds the AGL',
        [T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_MID_SPAN_HEIGHT_EXCEED_AGL]: 'The span-guy mid span height exceeds the AGL',
        [T.REASON_SPIDA_CALC_SPAN_LINKING_SPAN_GUY_HEIGHT_EXCEED_AGL]: 'The span-guy height exceeds the AGL',
        [T.REASON_EXPORT_IMPORTABLE_EXCEL_MULTIPLE_FORM_VERSIONS]: 'Collections contain multiple form versions',
        [T.REASON_EXPORT_IMPORTABLE_EXCEL_TOO_MANY_COLLECTIONS]: 'Cannot import more than 1000 collections at once',
        [T.REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_STRING]: 'Cell must contain text',
        [T.REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LATITUDE]: 'Cell must contain a positive or negative number',
        [T.REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LONGITUDE]: 'Cell must contain a positive or negative number',
        [T.REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_NUMBER]: 'Cell must contain a number',
        [T.REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_BOOLEAN]: 'Cell must contain TRUE or FALSE',
        [T.REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_ANCHOR]: 'Cell must contain Bisect, Inline, or Other',
        [T.REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LENGTH]: 'Cell must contain a length',
        [T.REASON_EXPORT_IMPORTABLE_EXCEL_CELL_FORMAT_MISMATCH_LENGTH_IMPERIAL]: 'Cell must contain a valid length in feet and inches (e.g. 5\' 11")',
        [T.REASON_EXPORT_IMPORTABLE_EXCEL_FORM_ID_MISMATCH]: 'Sheet is for importing a different Form',
        [T.REASON_EXPORT_IMPORTABLE_EXCEL_FORM_REVISION_MISMATCH]: 'Sheet is for a different revision of the Form',
        [T.REASON_EXPORT_IMPORTABLE_EXCEL_INVALID_DATE_FORMAT]: 'Invalid date format, must be YYYY-MM-DD',
        [T.REASON_EXPORT_IMPORTABLE_EXCEL_OPTION_DOES_NOT_EXIST]: 'Option does not exist',
        [T.REASON_EXPORT_IMPORTABLE_EXCEL_USER_NOT_FOUND]: 'User not found',
        [T.IMPORT_FILE_NO_ROWS]: 'The imported file had no Collection rows',
        [T.HELP_MENU]: 'Help & Resources',
        [T.SUBMIT_SUPPORT_REQUEST]: 'Submit Support Request',
        [T.SUPPORT_PORTAL]: 'Support Portal',
        [T.RELEASE_NOTES]: 'Release Notes',
        [T.REVISION_ID]: 'Revision ID',
        [T.MODIFIED_AT]: 'Modified At',
        [T.MODIFIED_BY]: 'Modified By',
        [T.MODIFICATIONS]: 'Modifications',
    },
};
function formatIpfSpanType(spanType) {
    switch (spanType) {
        case core_shared_1.IPFSpanType.FORE_SPAN:
            return 'Fore Span';
        case core_shared_1.IPFSpanType.BACK_SPAN:
            return 'Back Span';
        case core_shared_1.IPFSpanType.OTHER:
            return 'Other';
        default:
            const exhaustiveCheck = spanType;
            return exhaustiveCheck;
    }
}
function Translate(translateKey, attrs) {
    var currentTranslations = exports.TRANSLATIONS[exports.CURRENT_LANG];
    if (currentTranslations == null) {
        return translateKey;
    }
    var translation = currentTranslations[translateKey];
    if (translation == null) {
        return translateKey;
    }
    if (typeof translation === 'string') {
        return translation;
    }
    if (typeof translation === 'function') {
        return translation(attrs != null ? attrs : {});
    }
    throw new Error('Non string translations are not supported yet!');
}
//# sourceMappingURL=index.js.map